// BIDETAIL 2
import { isEmpty, isNumber } from "lodash";
import React, {
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AuthProvider from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import { apiGet, apiGet2 } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import Bookmaker from "./Bookmaker";
import MatchDetails from "./MatchDetails";
import Fancy from "./Fancy";
import ReactPlayer from "react-player";
import { categoryArray, premiumCategoryArray } from "../../Utils/constants";
import helpers from "../../Utils/helpers";
import PremiumFancyNew from "./PremiumFancyNew";
import axios from "axios";
import moment from "moment";
import obj from "../../Utils/constants";
import { io } from "socket.io-client";
import LoadingImage from "../../assets/images/cover-live.png";
import secureLocalStorage from "react-secure-storage";
import Toss from "./Toss";
import { useScrollPosition } from "react-use-scroll-position";
import RightLogoTv from "../../assets/images/logo.png";
import LiveMatchTrackerSoccer from "../Score/Soccer.js/ScoreBoardSoccer";
import LiveMatchTrackerCricket from "../Score/Cricket/ScoerBoardDetail";
import LiveMatchTrackerTennis from "../Score/Tennis/ScoreBoard";
import LayoutComponent from "../../components/shared/Layout";

function BidDetail() {
  const parmas = useParams();
  const navigate = useNavigate();
  let {
    user,
    setLoader,
    setIsTv,
    isTv,
    profileData,
    setFancyRules,
    setPremiumFancyRules,
    setMarketDepth,
    setMarketDepthData,
    loader,
    parly,
    setSocketId,
  } = useContext(AuthProvider);
  let {
    handelAddMultiMarket,
    multimarketLoader,
    betLoader,
    setBetLoader,
    betSelectionObj,
    isBetPlaced,
    betPlacedCheck,
    setBetPlacedCheck,
    messaageBox,
    updatePosition,
    setBetSelectionObj,
  } = useContext(BetSlipContext);
  const { y } = useScrollPosition();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [details, setDetails] = useState({});
  const [totalMatched, setTotalMatched] = useState({});
  const [selections, setSelections] = useState([]);
  const [jsonTieData, setJsonTieData] = useState([]);
  const [position, setPosition] = useState({});
  const [bookmakerData, setBookmerData] = useState({});
  const [bookmakerSelections, setBookmakerSelections] = useState([]);
  const [back_odds, setBackOdds] = useState([]);
  const [lay_odds, setLayOdds] = useState([]);
  const [back_oddsTie, setBackOddsTie] = useState([]);
  const [lay_oddsTie, setLayOddsTie] = useState([]);
  const [back_oddsToss, setBackOddsToss] = useState([]);
  const [tossObj, setTossObj] = useState([]);
  const [tempSelection, setTempSelection] = useState([]);
  const [selectionDemo, setSelectionDemo] = useState([]);
  const [fancyList, setFancyList] = useState([]);
  const [betFairMs, setBetFairMs] = useState(1);
  const [fancyPosition, setFancyPosition] = useState([]);
  const [tossList, setTossList] = useState([]);
  const [premiumFancyPosition, setPremiumFancyPosition] = useState([]);
  const [bookmakerBackOdds, setBookmakerBackOdds] = useState([]);
  const [bookmakerLayOdds, setBookmakerLayOdds] = useState([]);
  const [fancyCategory, setFancyCategory] = useState([]);
  const [fancyCategoryTabArray, setFancyCategoryTabArray] = useState([]);
  const [preminumFancy, setPremiumFancy] = useState([]);
  const [preminumFancyTab, setPremiumFancyTab] = useState([]);
  const [mute, setMute] = useState(true);
  const [condi, setCondi] = useState(false);
  const [key, setKey] = useState("Fancy Bet");
  const [popupMessage, setPopupMessage] = useState(false);
  const [slipObj, setSlipObj] = useState({});
  const [marketName, setMarketName] = useState("Match Odds");
  const [selectedTab, setSelectedTab] = useState("All");
  const [scoreId, setScoreId] = useState("0");
  const [minSportBook, setMinSportBook] = useState(1);
  const [seek, setSeek] = useState(true);
  const [checkRefresh, setCheckRefresh] = useState(true);
  const [checkTvRefresh, setTvCheckRefresh] = useState(true);
  let [pop, setPop] = useState("");
  const [controls, setControls] = useState(true);
  const [showInplaySlip, setShowInplaySlip] = useState(false);
  const ref = useRef(null);
  const currentOdds = useRef(betSelectionObj?.betType); // same value
  const [tScore, setTScore] = useState();
  const [tab, setTab] = useState("match");
  const [activeSportBook, setActiveSportBook] = useState([]);
  const [scorecard, setScoreCard] = useState("");

  // Alternative TV states (similar to ref.fullmarket.jsx)
  const [isGliveTv, setIsGliveTv] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [gliveTvLoaded, setGliveTvLoaded] = useState(false);
  const [scoreURL2, setScoreURL2] = useState(null);

  const mergedResultRef = useRef(null);

  // Get flags from location state (passed from Sports page)
  const location = useLocation();

  // useEffect(() => {
  //   const refreshFlagKey = 'bidDetailRefresh';

  //   // Check if the refresh flag is set in sessionStorage upon component mount
  //   const isRefreshOnPage = sessionStorage.getItem(refreshFlagKey);
  //   if (isRefreshOnPage === 'true') {
  //     console.log("Detected refresh on BidDetail page, redirecting to '/'");
  //     // Optionally, clear the flag before redirecting
  //     sessionStorage.removeItem(refreshFlagKey);
  //     navigate('/'); // Redirect to home
  //     return; // Exit early to prevent further execution on this 'instance' if redirecting
  //   }
  //   sessionStorage.setItem(refreshFlagKey, 'true');

  // }, [navigate]); // Depen

  // console.log(location?.state, 'itemitemitemitemitemitem');

  const [hasBookmaker, setHasBookmaker] = useState(
    location?.state?.hasBookmaker || location?.state?.bookMaker === "on",
  );

  const [hasFancy, setHasFancy] = useState(
    location?.state?.hasFancy || location?.state?.fancy === "on",
  );

  const [hasPremiumFancy, setHasPremiumFancy] = useState(
    location?.state?.hasPremiumFancy || location?.state?.premiumFancy === "on",
  );

  // Update flags from details API response (API takes precedence if it says enabled)
  // useEffect(() => {
  //   if (details) {
  //     // Update hasBookmaker if details says bookmaker is available
  //     if (details?.bookMaker === "on" || details?.hasBookMakerMarkets) {
  //       setHasBookmaker(true);
  //     }
  //     // Update hasFancy if details says fancy is available
  //     if (details?.fancy === "on" || details?.isFancyEnable || details?.hasFancyBetMarkets) {
  //       setHasFancy(true);
  //       setKey("Fancy Bet")
  //     } else {
  //       setKey("Preminum Fancy")
  //     }
  //     // Update hasPremiumFancy if details says premium fancy/sportsbook is available
  //     if (details?.premiumFancy === "on" || details?.hasSportBook || details?.hasSportsBookMarkets) {
  //       setHasPremiumFancy(true);
  //     }
  //   }
  // }, [details]);

  useEffect(() => {
    const fetchScoreCard = async () => {
      try {
        const { status, data: response_users } = await apiGet(
          apiPath.getScoreCard + `?eventId=${parmas?.eventId}`,
        );

        if (status === 200 && response_users?.status) {
          setScoreCard(response_users?.data?.scoreCardURL);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchScoreCard();
  }, []);

  // Fetch scoreboard URL for alternative TV display
  useEffect(() => {
    const fetchScoreboard = async () => {
      try {
        const { status, data: response_users } = await apiGet(
          apiPath.getScoreboard + `?eventId=${parmas?.eventId}`,
        );

        if (status === 200 && response_users?.status) {
          setScoreURL2(response_users?.data?.scoreCardURL);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchScoreboard();
  }, [parmas?.eventId]);

  // Fetch TV details to determine if Glive TV (iframe) or ReactPlayer (m3u8) should be used
  useEffect(() => {
    const fetchTvDetails = async () => {
      try {
        const { status, data: response_users } = await apiGet(
          apiPath.getTv + `?eventId=${parmas?.eventId}`,
        );

        if (status === 200 && response_users?.status) {
          if (response_users?.data?.tv) {
            setIsGliveTv(true);
            setIframeLoaded(false);
            setGliveTvLoaded(false);
          } else {
            setIsGliveTv(false);
            setIframeLoaded(false);
            setGliveTvLoaded(false);
          }
        } else {
          setIsGliveTv(false);
          setIframeLoaded(false);
          setGliveTvLoaded(false);
        }
      } catch (error) {
        console.error("Error fetching tv details:", error);
        setIsGliveTv(false);
        setIframeLoaded(false);
        setGliveTvLoaded(false);
      }
    };

    fetchTvDetails();
  }, [parmas?.eventId]);

  const setSelectedTabFunc = (id) => {
    if (id == "All") {
      setFancyCategoryTabArray(fancyList);
    } else if (id == "More") {
      let arr = fancyList?.filter(
        (res) =>
          res?.categoryType !== 1 &&
          res?.categoryType !== 2 &&
          res?.categoryType !== 3 &&
          res?.categoryType !== 4 &&
          res?.categoryType !== 5 &&
          res?.categoryType !== 6 &&
          res?.categoryType !== 7 &&
          res?.categoryType !== 8 &&
          res?.categoryType !== 9 &&
          res?.categoryType !== 10 &&
          res?.categoryType !== 11 &&
          res?.categoryType !== 14,
      );
      setFancyCategoryTabArray(arr);
    } else {
      let temp = fancyList?.filter((res) => {
        return res?.categoryType == id;
      });
      setFancyCategoryTabArray(temp);
    }
    setSelectedTab(id);
  };

  const [marketNew, setMarketNew] = useState([]);

  /**
   * Normalize jsonData keys to consistent PascalCase format
   * Cricket uses: SelectionId, RunnerName
   * Tennis/Soccer uses: selectionId, runnerName
   */
  const normalizeJsonData = (jsonData) => {
    if (!jsonData || !Array.isArray(jsonData)) return jsonData;
    return jsonData.map((item) => {
      const normalized = {};
      Object.keys(item).forEach((key) => {
        // Normalize key names to PascalCase
        if (key === "selectionId") {
          normalized.SelectionId = item[key];
        } else if (key === "runnerName") {
          normalized.RunnerName = item[key];
        } else {
          normalized[key] = item[key];
        }
      });
      return normalized;
    });
  };

  const getMatchDetails = async (typeCheck = "") => {
    if (typeCheck !== "interval") {
      // setLoader(true);
    }
    let temp = user
      ? `?eventId=${parmas?.eventId}&userId=${user ? user?.user?._id : ""}`
      : `?eventId=${parmas?.eventId}`;
    const { status, data: response_users } = await apiGet(
      apiPath.matchDetail + temp,
    );
    if (status === 200) {
      if (response_users?.success) {
        if (typeCheck == "") {
          if (response_users?.results?.marketList?.length > 0) {
            let latest = response_users?.results?.marketList?.filter((res) => {
              return res?.jsonData?.length > 0;
            });
            latest?.forEach(function (item, i) {
              if (item.market === "Match Odds") {
                latest.splice(i, 1);
                latest.unshift(item);
              }
            });
            let temp = latest?.sort((a, b) => {
              return a.market > b.market;
            });
            // setMarketNew(temp || []);
            let filteredArray = latest?.filter((res) => {
              return res?.marketId == parmas?.marketId;
            });
            const normalizedJsonData = normalizeJsonData(
              filteredArray[0]?.jsonData,
            );
            // setSelections(normalizedJsonData || []);
            setTempSelection(normalizedJsonData || []);
            setMarketName(filteredArray[0]?.market);
          } else {
            const normalizedJsonData = normalizeJsonData(
              response_users?.results?.jsonData,
            );
            // setSelections(normalizedJsonData || []);
            setTempSelection(normalizedJsonData || []);
          }
          const result = {
            centralizedId: response_users?.results?.centralizedId || "",
            bookmakerCentralizedId:
              response_users.results?.bookmakerCentralizedId || "",
          };
          response_users?.results?.jsonData?.map((it) => {
            it.position = 0;
          });
          const fancyCentralizedIdArr = response_users?.results?.fancyList?.map(
            (rt) => rt.centralizedId,
          );
          let temp = categoryArray?.filter((f) =>
            response_users?.results?.fancyList?.some(
              (item) => item?.categoryType === f.type,
            ),
          );
          // setFancyCategoryTabArray(response_users?.results?.fancyList || []);
          // setFancyCategory(
          //   temp?.length > 0
          //     ? [
          //         { type: "All", name: "All" },
          //         ...temp,
          //         { type: "More", name: "More" },
          //       ]
          //     : [{ type: "All", name: "All" }]
          // );
          setScoreId(
            response_users?.results.scoreId == undefined
              ? "0"
              : response_users?.results.scoreId,
          );
          // setIsTv({
          //   id:
          //     response_users?.results?.streamingChannel == false ||
          //     response_users?.results?.streamingChannel == ""
          //       ? false
          //       : response_users?.results?.streamingChannel,
          //   status: response_users?.results?.streamingChannel ? true : false,
          // });
          setIsTv({
            id: "1",
            status: true,
          });
          const normalizedJsonTieData = normalizeJsonData(
            response_users?.results?.jsonTieData,
          );
          setJsonTieData(normalizedJsonTieData || []);
          const normalizedMarketDepthData = normalizeJsonData(
            response_users?.results?.jsonData,
          );
          setMarketDepthData({
            array: normalizedMarketDepthData || [],
            matchName: response_users?.results?.eventName,
          });
          setDetails(response_users?.results);
          setTotalMatched(response_users?.results?.totalMatched);
          setLoader(false);
          const normalizedSelectionDemo = normalizeJsonData(
            response_users?.results?.jsonData,
          );
          setSelectionDemo(normalizedSelectionDemo || []);
          const normalizedBookmakerSelections = normalizeJsonData(
            response_users?.results?.jsonData,
          );
          // setBookmakerSelections(normalizedBookmakerSelections || []);
          const normalizedTossList = normalizeJsonData(
            response_users?.results?.jsonData,
          );
          setTossList(normalizedTossList || []);
          if (
            response_users?.results?.isFancyEnable ||
            response_users?.results?.provider == "diamond" ||
            response_users?.results?.fancy == "on"
          ) {
            // setKey("Fancy Bet");
          } else {
            if (
              response_users?.results?.gameType == "cricket" &&
              !response_users?.results?.eventName.includes(" SRL ")
            ) {
              if (
                response_users?.results?.fancyList?.length == 0 &&
                !isEmpty(user)
              ) {
                if (response_users?.results.fancy == "off") {
                  // setKey("Preminum Fancy");
                } else if (response_users?.results.premiumFancy == "off") {
                  // setKey("Fancy Bet");
                } else {
                  !response_users?.results?.eventName.includes(" T10 ");
                  // ? setKey("Preminum Fancy")
                  // : setKey("Fancy Bet");
                }
              } else {
                if (response_users?.results.fancy == "off") {
                  // setKey("Preminum Fancy");
                } else if (response_users?.results.premiumFancy == "off") {
                  // setKey("Fancy Bet");
                } else {
                  // setKey("Fancy Bet");
                }
              }
            } else {
              // setKey("Preminum Fancy");
            }
          }
        } else {
          setDetails(response_users?.results);
          setTotalMatched(response_users?.results?.totalMatched);
        }
        setCheckRefresh(true);
      }
      setLoader(false);
    }
  };

  // const transformPremiumFancyData = (newData) => {
  //   // Check for error response from socket (subCode 404 or status false)
  //   if (newData?.status === false || newData?.subCode === 404) {
  //     return null;
  //   }
  //   if (!newData || !newData.data || !Array.isArray(newData.data) || newData.data.length === 0) {
  //     return null;
  //   }
  //   // console.log(newData)
  //   const premiumMarkets = newData.data;
  //   const transformedData = premiumMarkets.map(market => {
  //     // Convert geniusSportsSelection to sportsBookSelection format
  //     const sportsBookSelection = market.geniusSportsSelection ? market.geniusSportsSelection.map(selection => ({
  //       apiSiteSelectionId: selection.apiSiteSelectionId.toString(),
  //       id: selection.id,
  //       selectionName: selection.selectionName,
  //       isActive: selection.isActive,
  //       status: selection.isActive, // Using isActive as status
  //       odds: selection.odds,
  //       sort: null // No sort info in new data
  //     })) : [];
  //     // Create markets object similar to old format
  //     const marketsObj = {
  //       id: market.id,
  //       eventId: market.eventId,
  //       apisite: 2, // Default value as in old format
  //       apiSiteMarketId: market.apiSiteMarketId,
  //       eventType: market.eventType,
  //       betfairEventId: market.betfairEventId,
  //       marketName: market.marketName,
  //       numberOfWinner: market.numberOfWinner,
  //       numberOfActiveRunners: market.numberOfActiveRunners,
  //       marketStatus: market.marketStatus,
  //       isExpand: market.isExpand,
  //       closeSite: market.closeSite,
  //       bookMode: market.bookMode || "[]", // Default to empty array string
  //       apiSiteStatus: market.apiSiteStatus,
  //       apiSiteSpecifier: "", // Not available in new format
  //       updateDate: market.updateDate,
  //       min: market.min,
  //       max: market.max,
  //       sportsBookSelection: market.geniusSportsSelection || [],
  //       selectionTs: market.selectionTs
  //     };
  //     return {
  //       betfairEventId: market.betfairEventId,
  //       id: market.id,
  //       apiSiteSelectionId: `${market.betfairEventId}S${market.id}`, // Creating similar format
  //       selectionId: market.id,
  //       marketId: `${market.betfairEventId}S${market.id}`, // Creating similar format
  //       marketStatus: market.marketStatus.toString(), // Converting to string as in old format
  //       apiSiteStatus: market.apiSiteStatus,
  //       marketName: market.marketName,
  //       name: market.marketName,
  //       centralizedId: `${market.betfairEventId}S${market.id}`, // Creating similar format
  //       sportsBookSelection: sportsBookSelection,
  //       markets: marketsObj,
  //       is_enable: market.marketStatus === 1 || market.apiSiteStatus === "ACTIVE", // Assuming active if status is 1
  //       eventId: market.betfairEventId.toString(),
  //       odd_ts: new Date(market.updateDate).toISOString().replace('T', ' ').substring(0, 19),
  //       ts: new Date(market.updateDate).toISOString().replace('T', ' ').substring(0, 19),
  //       oldSportsBookSelection: sportsBookSelection // Same as sportsBookSelection
  //     };
  //   });
  //   return {
  //     success: newData.status,
  //     message: newData.message,
  //     results: {
  //       data: transformedData
  //     }
  //   };
  // };

  // Updated function
  const getPremiumFancyList = async () => {
    const { status, data: response_users } = await apiGet2(
      apiPath.getPremiumFancy + `?match_id=${parmas.eventId}`,
    );
    if (status === 200) {
      if (response_users.status) {
        // Transform new data format to old format
        const transformedData = transformPremiumFancyData(response_users);
        let temp =
          transformedData?.results?.data?.length > 0
            ? transformedData?.results?.data?.filter((res) => {
                return res?.sportsBookSelection?.length > 0;
              })
            : [];
        setPremiumFancy(
          temp?.length > 0
            ? temp?.map((res, index) => {
                return { ...res, check: index < 5 ? true : false };
              })
            : [],
        );
        // let temp1 = premiumCategoryArray?.filter((f) =>
        //   response_users?.results?.data?.some(
        //     (item) => item.categoryType === f.type
        //   )
        // );
        // setPremiumFancyTabArr(response_users?.results.data || []);
        setPremiumFancyTab([
          { type: "All", name: "All" },
          ...premiumCategoryArray,
          { type: "More", name: "More" },
        ]);
      }
    }
  };

  const transformMatchDataToOldFormat = (newData) => {
    if (
      !newData ||
      !newData.data ||
      !Array.isArray(newData.data) ||
      newData.data.length === 0
    ) {
      return null;
    }
    // For soccer, if data array has more than one market, filter by marketId from params
    let marketData;
    if (details?.gameType === "soccer" && newData.data.length > 1) {
      marketData = newData.data.find(
        (item) => item.marketId === parmas?.marketId,
      );
    } else {
      marketData = newData.data[0];
    }

    if (!marketData) {
      return null;
    }

    // Determine market status (ms) based on status string
    const msValue =
      marketData.status === "OPEN"
        ? 1
        : marketData.status === "SUSPENDED"
          ? 3
          : 1; // Default to 1 (OPEN)
    // Create runners array similar to old format
    const runners = marketData.selections.map((selection) => ({
      selectionId: selection.selectionId,
      handicap: selection.handicap,
      status: selection.status,
      lastPriceTraded: selection.lastPriceTraded,
      totalMatched: selection.totalMatched,
      adjustmentFactor: 0, // Assuming this was always 0 in old format
      ex: {
        availableToBack:
          selection.availableToBack.length > 0
            ? selection.availableToBack
            : [
                { price: 0, size: 0 },
                { price: 0, size: 0 },
                { price: 0, size: 0 },
              ],
        availableToLay:
          selection.availableToLay.length > 0
            ? selection.availableToLay
            : [
                { price: 0, size: 0 },
                { price: 0, size: 0 },
                { price: 0, size: 0 },
              ],
      },
    }));
    // Create rt array from selections' availableToBack and availableToLay
    let rt = [];
    marketData.selections.forEach((selection) => {
      // Add back odds (ib: true)
      if (selection.availableToBack && selection.availableToBack.length > 0) {
        selection.availableToBack.forEach((back) => {
          rt.push({
            ri: selection.selectionId,
            rt: back.price,
            bv: back.size,
            ib: true,
          });
        });
      } else {
        // Add empty back positions
        for (let i = 0; i < 3; i++) {
          rt.push({
            ri: selection.selectionId,
            rt: 0,
            bv: 0,
            ib: true,
          });
        }
      }
      // Add lay odds (ib: false)
      if (selection.availableToLay && selection.availableToLay.length > 0) {
        selection.availableToLay.forEach((lay) => {
          rt.push({
            ri: selection.selectionId,
            rt: lay.price,
            bv: lay.size,
            ib: false,
          });
        });
      } else {
        // Add empty lay positions
        for (let i = 0; i < 3; i++) {
          rt.push({
            ri: selection.selectionId,
            rt: 0,
            bv: 0,
            ib: false,
          });
        }
      }
    });
    // Construct the old format object
    const oldFormat = {
      success: newData.status,
      message: newData.message,
      results: {
        mi: marketData.marketId,
        ms: msValue, // Using determined status value (1 for OPEN, 3 for SUSPENDED)
        totalMatched: marketData.totalMatched,
        rt: rt,
        runners: runners,
        lastMatchTime: marketData.lastMatchTime,
        ts: new Date().toISOString().replace("T", " ").substring(0, 19), // Current timestamp in old format
        eventId: parmas.eventId, // Default eventId since not present in new data
      },
    };
    return oldFormat;
  };

  // Updated function
  const getMatchData = async (id) => {
    // Add this check at the beginning of getMatchData
    // If selections were already set via WebSocket for the initial load, don't fetch API data for the initial load
    // This prevents the initial API call from overriding fresh WebSocket data
    if (hasSetSelections.current && !id) {
      console.log(
        "getMatchData: Skipping initial API call as selections are already set via WebSocket.",
      );
      return;
    }

    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds + `?match_ids=${!isEmpty(id) ? id : parmas.eventId}`,
    );
    if (status === 200) {
      if (response_users.status) {
        // Transform new data format to old format
        const transformedData = transformMatchDataToOldFormat(response_users);
        const socket_data = transformedData?.results;

        // **** CRITICAL CHANGE HERE ****
        // Only update selections state if the API call is for a specific market update (id provided)
        // OR if selections haven't been set yet (which should be rare now due to the check above).
        // This prevents the general interval call from overwriting WebSocket selections.
        if (response_users?.data?.[0]?.selections) {
          // For soccer, if data array has more than one market, filter by marketId from params
          let marketData;
          if (
            details?.gameType === "soccer" &&
            response_users.data.length > 1
          ) {
            marketData = response_users.data.find(
              (item) => item.marketId === parmas?.marketId,
            );
          } else {
            marketData = response_users.data[0];
          }

          if (marketData?.selections) {
            const normalizedJsonData = normalizeJsonData(marketData.selections);

            // Update selections only if it's a targeted market refresh (id exists)
            // OR if selections haven't been initialized by WebSocket yet (less likely due to check above)
            if (!isEmpty(id) || !hasSetSelections.current) {
              setSelections(normalizedJsonData);
              setBookmakerSelections(normalizedJsonData);
              // If setting selections here for the first time (not via WebSocket), update the flag
              if (!hasSetSelections.current) {
                hasSetSelections.current = true;
              }
            } else {
              // console.log("getMatchData: API selections received, but skipping update to 'selections' state as WebSocket data should take precedence for initial load and continuous updates are handled by socket.");
            }
          }
        }
        // ******************************

        if (
          socket_data &&
          socket_data?.eventId &&
          parmas?.eventId == socket_data?.eventId &&
          socket_data?.mi == (!isEmpty(id) ? id : parmas.marketId)
        ) {
          if (socket_data.ms) {
            setBetFairMs(socket_data.ms);
          }
          if (socket_data.rt?.length) {
            const back_odds = socket_data?.rt?.filter((rt) => rt.ib) || [];
            const lay_odds = socket_data?.rt?.filter((rt) => !rt.ib) || [];
            setBackOdds(back_odds);
            setLayOdds(lay_odds);
            setTotalMatched(socket_data?.totalMatched);
          }
          if (!isEmpty(id)) {
            setCheckRefresh(true);
          }
        }
      }
    }
  };

  const transformBookmakerData = (newData, eventId) => {
    const getStatusBasedOnStatus = (status) => {
      if (typeof status === "number") return status;
      switch (status) {
        case "ACTIVE":
        case "OPEN":
          return 1;
        case "INACTIVE":
          return 2;
        case "SUSPENDED":
          return 3;
        case "CLOSED":
          return 4;
        case "BALL_RUNNING":
          return 9;
        default:
          return 1;
      }
    };

    if (!newData || !newData.data) return null;

    const { markets, selections } = newData.data;

    const market = markets.marketId ? markets : Object.values(markets)[0];
    if (!market || !market.marketId) return null;

    const selectionEntries = Array.isArray(selections)
      ? selections
      : Object.values(selections);
    if (!selectionEntries || selectionEntries.length === 0) return null;

    const rt = [];

    // ✅ Build selections array directly in the transform
    const bookmakerSelections = selectionEntries.map((selection) => {
      let backOdds = [];
      let layOdds = [];
      try {
        backOdds = JSON.parse(selection.backOddsInfo) || [];
        layOdds = JSON.parse(selection.layOddsInfo) || [];
      } catch (e) {
        backOdds = [];
        layOdds = [];
      }

      const backOddValue =
        backOdds.length > 0 && backOdds[0] && backOdds[0] !== ""
          ? parseFloat(backOdds[0]) || 0
          : 0;
      const layOddValue =
        layOdds.length > 0 && layOdds[0] && layOdds[0] !== ""
          ? parseFloat(layOdds[0]) || 0
          : 0;

      rt.push({
        SelectionId: selection.selectionId,
        ri: selection.selectionId,
        sid: selection.selectionId,
        name: selection.runnerName,
        runnerName: selection.runnerName,
        RunnerName: selection.runnerName,
        rt: backOddValue,
        bv: backOddValue,
        ib: true,
        ms: getStatusBasedOnStatus(selection.status),
      });

      rt.push({
        ri: selection.selectionId,
        sid: selection.selectionId,
        name: selection.runnerName,
        runnerName: selection.runnerName,
        RunnerName: selection.runnerName,
        rt: layOddValue,
        bv: layOddValue,
        ib: false,
        ms: getStatusBasedOnStatus(selection.status),
      });

      // ✅ Return a clean selection object for bookmakerSelections state
      return {
        SelectionId: selection.selectionId,
        RunnerName: selection.runnerName,
        position: 0,
        newPosition: 0,
      };
    });

    return {
      status: newData.status,
      message: newData.message,
      results: {
        bmi: market.marketId.toString(),
        ip: 1,
        mi: market.marketId.toString(),
        eid: market.eventId || eventId || 0,
        grt: null,
        rt: rt,
        ms: getStatusBasedOnStatus(market.status),
        ts: new Date().toISOString().replace("T", " ").substring(0, 19),
        selections: bookmakerSelections, // ✅ included in results
      },
      eventId: eventId.toString(),
    };
  };

  const getBookmakerData = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getBookmakerMarket +
        `?match_id=${!isEmpty(id) ? id : parmas.eventId}`,
    );
    if (status === 200) {
      if (response_users.status) {
        const message = transformBookmakerData(response_users, parmas?.eventId);
        if (message.eventId === parmas?.eventId) {
          setBookmerData(message?.results);
          setBookmakerSelections((prev) => {
            return prev?.map((res) => {
              let temp = message?.results?.rt.find((item) => {
                return item?.name === res?.RunnerName;
              });
              if (temp?.name === res?.RunnerName) {
                return {
                  ...res,
                  ...temp,
                };
              } else {
                return { ...res, ...temp };
              }
            });
          });
          const back_odds = message?.results?.rt.filter((rt) => rt.ib) || [];
          const lay_odds = message?.results?.rt.filter((rt) => !rt.ib) || [];
          setBookmakerLayOdds(lay_odds);
          setBookmakerBackOdds(back_odds);
        }
      }
    }
  };

  const transformFancyData = (newData) => {
    if (!newData || !newData.data) {
      return null;
    }
    const getMsFromStatus = (fancy, rt) => {
      if (fancy.status === 10) return "9"; // Ball Running
      if (fancy.status === 2) return "1"; // Active
      if (fancy.status === 4) return "4"; // Closed
      if (fancy.status === 6 || !rt || rt.length === 0) return "3"; // Suspended
      return "1"; // Default Active
    };

    const fancyMarkets = newData.data;
    const transformedResults = fancyMarkets.map((fancy) => {
      // Create rt array with two entries: one for YES (true/ib=true) and one for NO (false/ib=false)
      const rt = [
        {
          ri: fancy.marketId,
          rt: fancy.runsNo, // For NO side
          ib: false, // NO side
          pt: fancy.oddsNo,
        },
        {
          ri: fancy.marketId,
          rt: fancy.runsYes, // For YES side
          ib: true, // YES side
          pt: fancy.oddsYes,
        },
      ];
      // Create jsonData object similar to old format
      const jsonData = {
        eventType: fancy.eventType,
        eventId: fancy.eventId,
        marketId: fancy.marketId,
        marketType: fancy.marketType,
        status: fancy.status,
        summaryStatus: fancy.summaryStatus,
        sort: fancy.sort,
        eventName: fancy.eventName,
        marketName: fancy.marketName,
        runsNo: fancy.runsNo,
        runsYes: fancy.runsYes,
        oddsNo: fancy.oddsNo,
        oddsYes: fancy.oddsYes,
        oddsVersion: fancy.oddsVersion,
        resultRuns: fancy.resultRuns,
        updateDate: fancy.updateDate,
        oddsSettingUpdateDate: fancy.oddsSettingUpdateDate,
        min: fancy.min,
        max: fancy.max,
        rebateRatio: fancy.rebateRatio,
        delayBetting: fancy.delayBetting,
        remarkFirstRow: fancy.remarkFirstRow,
        remarkSecondRow: fancy.remarkSecondRow,
      };
      return {
        eventId: fancy.eventId.toString(),
        mid: `${fancy.eventId}S${fancy.marketId}`, // Creating mid like old format
        selectionId: fancy.marketId,
        mi: `${fancy.eventId}S${fancy.marketId}`, // Creating mi like old format
        ms: getMsFromStatus(fancy, rt),
        sstatus: fancy.status,
        eid: fancy.marketId,
        fancyName: fancy.marketName,
        name: fancy.marketName,
        srno: fancy.sort,
        jsonData: jsonData,
        centralizedId: `${fancy.eventId}S${fancy.marketId}`, // Creating centralizedId like old format
        min: fancy.min,
        max: fancy.max,
        categoryType: fancy.marketType,
        oddsNo: fancy.oddsNo,
        oddsYes: fancy.oddsYes,
        sid: fancy.marketId,
        b1: fancy.runsYes, // YES side runs
        bs1: fancy.oddsYes, // YES side odds
        l1: fancy.runsNo, // NO side runs
        ls1: fancy.oddsNo, // NO side odds
        ts: new Date().toISOString().replace("T", " ").substring(0, 19), // Current timestamp in old format
        OddsTime: new Date(fancy.updateDate)
          .toISOString()
          .replace("T", " ")
          .substring(0, 19),
        OddsExpireTime: new Date(fancy.updateDate + 5000)
          .toISOString()
          .replace("T", " ")
          .substring(0, 19), // Adding 5 seconds as example expiry
        rt: rt,
      };
    });
    return {
      success: newData.status,
      message: newData.message,
      results: transformedResults,
    };
  };

  // Updated function
  const getFancyData = async () => {
    const { status, data: message } = await apiGet(
      // apiPath.getFancyOdds + `?eventId=${parmas.eventId}`
      apiPath.getFancyOdds + `?match_id=${parmas.eventId}`,
    );
    if (status === 200) {
      if (message.status) {
        // Transform new data format to old format
        const transformedData = transformFancyData(message);
        if (transformedData?.results?.length > 0) {
          let temp = categoryArray?.filter((f) =>
            transformedData?.results?.some(
              (item) => item?.categoryType === f.type,
            ),
          );
          setFancyCategory(
            temp.length > 0
              ? [
                  { type: "All", name: "All" },
                  ...temp,
                  { type: "More", name: "More" },
                ]
              : [{ type: "All", name: "All" }],
          );
          setPremiumFancyTab([
            { type: "All", name: "All" },
            ...premiumCategoryArray,
            { type: "More", name: "More" },
          ]);
          setFancyPosition((prev) => {
            setFancyList(
              transformedData?.results?.map((res) => {
                let obj = prev?.find(
                  (item) =>
                    item.selectionId == res.selectionId &&
                    item.fancyName == res.name,
                );
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                  position: !isEmpty(obj) ? obj?.position : "",
                };
              }),
            );
            setFancyCategoryTabArray(
              transformedData?.results?.map((res) => {
                let obj = prev?.find(
                  (item) =>
                    item.selectionId == res.selectionId &&
                    item.fancyName == res.name,
                );
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                  position: !isEmpty(obj) ? obj?.position : "",
                };
              }),
            );
            return prev;
          });
        }
      }
    }
  };

  // Initialize initial states immediately
  useEffect(() => {
    // Initialize selections and odds with empty arrays to prevent undefined errors
    setSelections([]);
    setBackOdds([]);
    setLayOdds([]);
    setBookmakerSelections([]);
    setBookmakerBackOdds([]);
    setBookmakerLayOdds([]);
    setFancyList([]);
    setFancyCategoryTabArray([]);
    setPremiumFancy([]);
  }, []);

  useEffect(() => {
    let interval = setInterval(() => {
      if (!parly) {
        getFancyData();
        getMatchData();
        // getBookmakerData()
      }
      getMatchDetails("interval");
      // getPremiumFancyList();
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, [parly, parmas]);

  useEffect(() => {
    // Start loading initial data immediately
    if (!parly) {
      getFancyData();
      getMatchData();
      getBookmakerData();
    }
    getMatchDetails();
    // getPremiumFancyList();
  }, []);

  useEffect(() => {
    let interval = setInterval(() => {
      if (!parly) {
        getFancyData();
        getMatchData();
        // getBookmakerData()
      }
      getMatchDetails("interval");
      getPremiumFancyList();
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    currentOdds.current = betSelectionObj?.betType;
  }, [betSelectionObj?.betType]);

  useEffect(() => {
    if (multimarketLoader) {
      setTimeout(() => {
        getMatchDetails("multi");
      }, 1000);
    }
  }, [multimarketLoader]);

  const suspensionTimersRef = useRef({});

  const transformPremiumFancyData = (newData) => {
    if (newData?.status === false || newData?.subCode === 404) {
      return null;
    }
    if (
      !newData ||
      !newData.data ||
      !Array.isArray(newData.data) ||
      newData.data.length === 0
    ) {
      return null;
    }

    const premiumMarkets = newData.data;
    const transformedData = premiumMarkets.map((market) => {
      const sportsBookSelection = market.geniusSportsSelection
        ? market.geniusSportsSelection.map((selection) => ({
            apiSiteSelectionId: selection.apiSiteSelectionId.toString(),
            id: selection.id,
            selectionName: selection.selectionName,
            isActive: selection.isActive,
            status: selection.isActive,
            odds: selection.odds,
            sort: null,
          }))
        : [];

      const marketsObj = {
        id: market.id,
        eventId: market.eventId,
        apisite: 2,
        apiSiteMarketId: market.apiSiteMarketId,
        eventType: market.eventType,
        betfairEventId: market.betfairEventId,
        marketName: market.marketName,
        numberOfWinner: market.numberOfWinner,
        numberOfActiveRunners: market.numberOfActiveRunners,
        marketStatus: market.marketStatus,
        isExpand: market.isExpand,
        closeSite: market.closeSite,
        bookMode: market.bookMode || "[]",
        apiSiteStatus: market.apiSiteStatus,
        apiSiteSpecifier: "",
        updateDate: market.updateDate,
        min: market.min,
        max: market.max,
        sportsBookSelection: market.geniusSportsSelection || [],
        selectionTs: market.selectionTs,
      };

      return {
        betfairEventId: market.betfairEventId,
        id: market.id,
        apiSiteSelectionId: `${market.betfairEventId}S${market.id}`,
        selectionId: market.id,
        marketId: `${market.betfairEventId}S${market.id}`,
        marketStatus: market.marketStatus.toString(),
        apiSiteStatus: market.apiSiteStatus,
        marketName: market.marketName,
        name: market.marketName,
        centralizedId: `${market.betfairEventId}S${market.id}`,
        sportsBookSelection: sportsBookSelection,
        markets: marketsObj,
        is_enable:
          market.marketStatus === 1 || market.apiSiteStatus === "ACTIVE",
        eventId: market.eventId.toString(),
        odd_ts: new Date(market.updateDate)
          .toISOString()
          .replace("T", " ")
          .substring(0, 19),
        ts: new Date(market.updateDate)
          .toISOString()
          .replace("T", " ")
          .substring(0, 19),
        oldSportsBookSelection: sportsBookSelection,
      };
    });

    return {
      success: newData.status,
      message: newData.message,
      results: { data: transformedData },
    };
  };

  const suspendAndRemoveSportBook = (itemId) => {
    setPremiumFancy((current) =>
      current.map((item) =>
        item.id === itemId
          ? {
              ...item,
              apiSiteStatus: "SUSPENDED",
              markets: { ...item.markets, apiSiteStatus: "SUSPENDED" },
              is_enable: false,
            }
          : item,
      ),
    );

    suspensionTimersRef.current[itemId] = setTimeout(() => {
      setPremiumFancy((current) =>
        current.filter((item) => item.id !== itemId),
      );
      setPremiumFancyTab((current) =>
        current?.filter((item) => item.id !== itemId),
      );
      delete suspensionTimersRef.current[itemId];
    }, 5000);
  };

  const listenSportBook = (message2) => {
    if (message2?.status === false || message2?.subCode === 404) {
      return;
    }

    const socket_data = transformPremiumFancyData(message2);
    if (!socket_data?.success) return;

    if (!isEmpty(user)) {
      setPremiumFancyPosition((prev) => {
        setPremiumFancy(
          socket_data.results.data.map((res) => {
            let obj = prev?.filter(
              (item) => item?.fancyName === res?.marketName,
            );
            if (obj?.length > 0) {
              return {
                ...res,
                sportsBookSelection: res?.sportsBookSelection?.map((elem) => {
                  let temp = obj?.find(
                    (item) => elem?.id === item?.fancySelectionId,
                  );
                  return { ...elem, position: temp?.position ?? elem.position };
                }),
              };
            }
            return res;
          }),
        );
        return prev;
      });
    } else {
      setPremiumFancy(socket_data.results.data);
    }
  };

  const hasSetSelections = useRef(false);

  const listenBetfairOdds = (event2) => {
    const event = transformMatchDataToOldFormat(event2);
    // For soccer, if data array has more than one market, filter by marketId from params
    let marketData;
    if (details?.gameType === "soccer" && event2?.data?.length > 1) {
      marketData = event2.data.find(
        (item) => item.marketId === parmas?.marketId,
      );
    } else {
      marketData = event2?.data?.[0];
    }

    if (!hasSetSelections.current && marketData?.selections) {
      setLoader(true);
      const normalisedData = normalizeJsonData(marketData.selections);
      setSelections(normalisedData);
      hasSetSelections.current = true;
      setLoader(false);
    }
    if (event?.results?.mi === parmas?.marketId) {
      const socket_data = event?.results; // Get the results object directly after transformation
      // Ensure the event ID matches the current match
      if (
        socket_data &&
        socket_data?.eventId &&
        parmas?.eventId === socket_data?.eventId
      ) {
        // Update Market Status (ms) if present
        if (socket_data.ms) {
          setBetFairMs(socket_data.ms);
        }
        // Process and update Total Matched
        if (socket_data.totalMatched !== undefined) {
          setTotalMatched(socket_data.totalMatched);
        }
        // --- CRITICAL PART FOR MATCH DETAILS ---
        // Check if the 'rt' array exists and has data
        if (socket_data.rt?.length) {
          // Filter 'rt' array based on 'ib' flag for Back and Lay odds
          const back_odds_socket = socket_data.rt.filter((rt) => rt.ib) || [];
          const lay_odds_socket = socket_data.rt.filter((rt) => !rt.ib) || [];
          // Update the state variables that MatchDetails uses
          setBackOdds(back_odds_socket);
          setLayOdds(lay_odds_socket);
        }
      }
    }
  };

  // const suspensionTimersRef = useRef({});
  const fancySuspensionTimersRef = useRef({});

  const suspendAndRemoveFancy = (selectionId) => {
    setFancyList((current) =>
      current.map((item) =>
        item.selectionId === selectionId
          ? {
              ...item,
              ms: "3", // Suspended status
              sstatus: 6,
              odds: { ...item.odds, ms: "3" },
            }
          : item,
      ),
    );

    fancySuspensionTimersRef.current[selectionId] = setTimeout(() => {
      setFancyList((current) =>
        current.filter((item) => item.selectionId !== selectionId),
      );
      setFancyCategoryTabArray((current) =>
        current?.filter((item) => item.selectionId !== selectionId),
      );
      delete fancySuspensionTimersRef.current[selectionId];
    }, 5000);
  };

  const listenDiamondFancy = (message2) => {
    // Check for error response from socket (subCode 400/404 or status false)
    // console.log(message2?.data.length)
    if (
      message2?.status === false ||
      message2?.subCode === 400 ||
      message2?.subCode === 404
    ) {
      // Suspend all fancy markets and remove them after 5 seconds
      setFancyList((current) => {
        current.forEach((item) => {
          if (fancySuspensionTimersRef.current[item.selectionId]) {
            clearTimeout(fancySuspensionTimersRef.current[item.selectionId]);
            delete fancySuspensionTimersRef.current[item.selectionId];
          }
          suspendAndRemoveFancy(item.selectionId);
        });
        return current;
      });
      return;
    }

    const message = transformFancyData(message2);
    if (message?.success) {
      if (message?.results?.length > 0) {
        let temp = categoryArray?.filter((f) =>
          message?.results?.some((item) => item?.categoryType === f.type),
        );
        setFancyCategory(
          temp.length > 0
            ? [
                { type: "All", name: "All" },
                ...temp,
                { type: "More", name: "More" },
              ]
            : [{ type: "All", name: "All" }],
        );
        setPremiumFancyTab([
          { type: "All", name: "All" },
          ...premiumCategoryArray,
          { type: "More", name: "More" },
        ]);

        // Create a set of incoming selectionIds for quick lookup
        const incomingIds = new Set(
          message.results.map((item) => item.selectionId),
        );

        // Use functional updates consistently
        setFancyList((prevFancyList) => {
          // Suspend items missing from new data
          prevFancyList.forEach((item) => {
            if (
              !incomingIds.has(item.selectionId) &&
              !fancySuspensionTimersRef.current[item.selectionId]
            ) {
              suspendAndRemoveFancy(item.selectionId);
            }
          });

          // Cancel suspension timers for items that came back
          incomingIds.forEach((selectionId) => {
            if (fancySuspensionTimersRef.current[selectionId]) {
              clearTimeout(fancySuspensionTimersRef.current[selectionId]);
              delete fancySuspensionTimersRef.current[selectionId];
            }
          });

          return message?.results?.map((res) => {
            // Match using consistent properties (both selectionId and name like in getFancyData)
            let obj = prevFancyList?.find(
              (item) =>
                item.selectionId == res.selectionId &&
                item.fancyName == res.name,
            );
            return {
              ...res,
              odds: res,
              fancyName: res.name,
              position: !isEmpty(obj) ? obj?.position : "",
              newPosition:
                Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
            };
          });
        });
        setFancyCategoryTabArray((prevCategoryArray) => {
          return message?.results?.map((res) => {
            // Match using consistent properties
            let obj = prevCategoryArray?.find(
              (item) =>
                item.selectionId == res.selectionId &&
                item.fancyName == res.name,
            );
            return {
              ...res,
              odds: res,
              fancyName: res.name,
              position: !isEmpty(obj) ? obj?.position : "",
              newPosition:
                Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
            };
          });
        });
        // Only update fancy position if user exists
        if (!isEmpty(user)) {
          setFancyPosition((prev) => {
            // Update positions based on the new data
            return prev.map((prevItem) => {
              const updatedItem = message.results.find(
                (res) =>
                  res.selectionId == prevItem.selectionId &&
                  res.name == prevItem.fancyName,
              );
              if (updatedItem) {
                return {
                  ...prevItem,
                  position: updatedItem.position || prevItem.position,
                  newPosition: updatedItem.newPosition || prevItem.newPosition,
                };
              }
              return prevItem;
            });
          });
        }
      }
    }
  };

  // Updated function
  const listenBookmakerData = (message2) => {
    // Pass message2 to the transformer to get the standardized object
    const message = transformBookmakerData(message2, parmas?.eventId);

    // Proceed only if the transformed message matches the current event ID
    if (message?.eventId === parmas?.eventId) {
      // Update the main bookmaker data state
      setBookmerData(message?.results);

      // Update bookmakerSelections state based on the transformed data
      setBookmakerSelections((prevSelections) => {
        // Start with the existing selections to preserve their state (like position, newPosition)
        const updatedSelections = [...prevSelections];

        // Iterate through the transformed rt array which holds the detailed odds/status info
        message?.results?.rt?.forEach((rtItem) => {
          // Find the corresponding selection in our current state array by matching RunnerName
          const index = updatedSelections.findIndex(
            (selection) => selection.RunnerName === rtItem.runnerName,
          );

          if (index !== -1) {
            // If found, update the existing selection object with new data from rtItem
            // This preserves fields like position, newPosition from the previous state
            // while updating odds, status, ms, etc., from the new data
            updatedSelections[index] = {
              ...updatedSelections[index], // Spread existing state
              SelectionId: rtItem.sid, // Update/ensure SelectionId
              RunnerName: rtItem.runnerName, // Update/ensure RunnerName
              rt: rtItem.rt, // Update odds value
              bv: rtItem.bv, // Update size/value
              ib: rtItem.ib, // Update back/lay flag
              ms: rtItem.ms, // Update market status for this selection
              // Note: status, sort, updateDate, eventId would need to come from
              // the original source data if they differ per back/lay. rtItem currently doesn't hold these.
              // If status is needed per selection and differs from ms, it should be added to rtItem in transform.
            };
          } else {
            // If not found, it means this runner might be new or the name didn't match initially.
            // We could potentially add it here, but usually, the initial list comes from getMatchDetails.
            // Adding here might be less common unless runners can dynamically appear/disappear.
            // For safety, we might just log or ignore if not found.
            // console.warn(`Selection for RunnerName '${rtItem.runnerName}' not found in current state.`);
          }
        });

        // Return the fully updated array to set the state
        return updatedSelections;
      });

      // Separate back and lay odds from the transformed data for other components
      const back_odds = message?.results?.rt?.filter((rt) => rt.ib) || [];
      const lay_odds = message?.results?.rt?.filter((rt) => !rt.ib) || [];
      setBookmakerLayOdds(lay_odds);
      setBookmakerBackOdds(back_odds);
    }
  };

  const listenCcoreT10 = (message) => {
    if (message?.results?.eventId === parmas?.eventId) {
      // console.log("message?.results", message?.results?.score);
      setTScore(message?.results?.score || {});
    }
  };

  const listenTie = (message) => {
    const socket_data =
      (message &&
        message?.results?.find((item) => item.eventId == parmas?.eventId)) ||
      [];
    if (
      socket_data &&
      socket_data?.eventId &&
      parmas?.eventId == socket_data?.eventId
    ) {
      if (socket_data.rt?.length) {
        const back_odds = socket_data.rt.filter((rt) => rt.ib) || [];
        const lay_odds = socket_data.rt.filter((rt) => !rt.ib) || [];
        setBackOddsTie(back_odds);
        setLayOddsTie(lay_odds);
      }
    }
  };

  const listenToss = (message) => {
    const socket_data =
      (message &&
        message?.results?.find((item) => item.eventId == parmas?.eventId)) ||
      [];
    if (
      socket_data &&
      socket_data?.eventId &&
      parmas?.eventId == socket_data?.eventId
    ) {
      if (socket_data.rt?.length) {
        const back_odds = socket_data.rt.filter((rt) => rt.ib) || [];
        setBackOddsToss(back_odds);
        setTossObj(socket_data);
      }
    }
  };

  const [socketObj, setSocketObj] = useState(null);
  const [socketObj2, setSocketObj2] = useState(null);

  const getSocket = () => {
    if (!parmas?.eventId) {
      return () => {};
    }

    let newSocket = "";
    let randomId = user?.user?._id ? user?.user?._id : 112233;

    if (!isEmpty(user)) {
      newSocket = io(
        `${import.meta.env.VITE_SOCKET}?match_id=${parmas?.eventId}`,
        {
          transports: ["websocket"],
          forceNew: true,
        },
      );
    } else {
      newSocket = io(
        `${import.meta.env.VITE_SOCKET}?match_id=${parmas?.eventId}`,
        {
          transports: ["websocket"],
          forceNew: true,
        },
      );
    }

    setSocketObj(newSocket);
    setSocketId(newSocket);

    if (!isEmpty(user)) {
      if (parly) {
        newSocket.on("premium_market", listenSportBook);
      } else {
        newSocket.on("fancy_market", listenDiamondFancy);
        newSocket.on("market_odds", listenBetfairOdds);
        newSocket.on("book_maker_market", listenBookmakerData);
        newSocket.on("premium_market", listenSportBook);
      }
    } else {
      newSocket.on("fancy_market", listenDiamondFancy);
      newSocket.on("market_odds", listenBetfairOdds);
      newSocket.on("book_maker_market", listenBookmakerData);
      newSocket.on("premium_market", listenSportBook);
    }

    // newSocket.on("disconnect", function () {
    //   setCheckRefresh(true);
    // });

    return () => {
      if (newSocket) {
        console.log("Disconnecting Socket 1");
        newSocket.disconnect();
      }
    };
  };

  const getSocket2 = () => {
    if (!parmas?.eventId) {
      return () => {};
    }

    let newSocket = "";

    if (!isEmpty(user)) {
      newSocket = io(
        `${import.meta.env.VITE_SOCKET2}?match_id=${parmas?.eventId}`,
        {
          transports: ["websocket"],
          forceNew: true,
        },
      );
    } else {
      newSocket = io(
        `${import.meta.env.VITE_SOCKET2}?match_id=${parmas?.eventId}`,
        {
          transports: ["websocket"],
          forceNew: true,
        },
      );
    }

    setSocketObj2(newSocket);
    setSocketId(newSocket);

    if (!isEmpty(user)) {
      if (parly) {
        newSocket.on("premium_market", listenSportBook);
      } else {
        newSocket.on("premium_market", listenSportBook);
      }
    } else {
      newSocket.on("premium_market", listenSportBook);
    }

    // newSocket.on("disconnect", function () {
    //   setCheckRefresh(true);
    // });

    return () => {
      if (newSocket) {
        console.log("Disconnecting Socket 2");
        newSocket.disconnect();
      }
    };
  };

  useEffect(() => {
    if (parmas?.eventId) {
      const cleanupSocket1 = getSocket();
      // const cleanupSocket2 = getSocket2();
      return () => {
        if (typeof cleanupSocket1 === "function") {
          cleanupSocket1();
        }
        // if (typeof cleanupSocket2 === 'function') {
        //   cleanupSocket2();
        // }
      };
    }
    return () => {};
  }, [checkRefresh, parmas?.eventId]);

  useEffect(() => {
    const handleVisibility = () => {
      if (!document.hidden && !isEmpty(user) && !checkRefresh) {
        setCheckRefresh(true);
        setTvCheckRefresh(true);

        socketObj?.disconnect();
        socketObj2?.disconnect();
      } else {
        setCheckRefresh(false);
        setTvCheckRefresh(false);
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [socketObj, socketObj2, user, checkRefresh]);

  const getBetPosition = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.betPosition +
        `?eventId=${parmas.eventId}&type=${details.gameType}&marketId=${
          !isEmpty(id) ? id : parmas?.marketId
        }`,
    );
    if (status === 200) {
      //BET FAIR
      if (response_users.success) {
        // if (response_users?.results?.betFair?.length > 0) {
        //   secureLocalStorage.setItem(
        //     "betFair",
        //     response_users?.results?.betFair
        //   );
        // }
        // if (response_users?.results?.bookmaker?.length > 0) {
        //   secureLocalStorage.setItem(
        //     "bookmaker",
        //     response_users?.results?.bookmaker
        //   );
        // }
        // if (response_users?.results?.tie?.length > 0) {
        //   secureLocalStorage.setItem("tie", response_users?.results?.tie);
        // }
        // if (response_users?.results?.toss?.length > 0) {
        //   secureLocalStorage.setItem("toss", response_users?.results?.toss);
        // }
        updatePositionNew(response_users?.results);
        setPosition(response_users?.results);
        setBetLoader(false);
      }
    }
  };

  const getFancyBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.betFancyPosition +
        `?eventId=${parmas.eventId}&type=${details.gameType}`,
    );
    if (status === 200) {
      if (response_users.success) {
        // secureLocalStorage.setItem(
        //   "fancy",
        //   response_users?.results?.map((res) => {
        //     return { selectionId: res?.selectionId, position: res?.position };
        //   }) || []
        // );
        updatedFancyPosition(
          response_users?.results?.map((res) => {
            return { selectionId: res?.selectionId, position: res?.position };
          }) || [],
        );
      }
    }
  };

  const getPremiumFancyBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.betPremiumFancyPosition +
        `?eventId=${parmas.eventId}&type=${details.gameType}`, // Note: 'parmas' typo?
    );

    if (status === 200) {
      if (response_users.success) {
        setPremiumFancyPosition(response_users?.results);

        setPremiumFancy((current) => {
          if (!current) return current; // Guard against null/undefined current

          return current?.map((res) => {
            // Find all position records that match this specific market's name
            let obj = response_users?.results?.filter((item) => {
              return item?.fancyName === res?.marketName; // Use strict equality (===)
            });

            if (obj?.length > 0) {
              // A position record exists for this market
              return {
                ...res,
                sportsBookSelection: res?.sportsBookSelection?.map((elem) => {
                  // Find the *specific* position record within 'obj'
                  // where the selection ID in the position record (fancySelectionId)
                  // matches the ID of the current selection being processed (elem.id)
                  let temp = obj?.find(
                    (item) => item?.fancySelectionId === elem?.id, // CORRECTED COMPARISON
                  );

                  return {
                    ...elem,
                    // Assign the position from the server record, or keep the existing one if not found
                    position: temp?.position ?? elem.position,
                  };
                }),
              };
            } else {
              // No position records were found for this market name, return original unchanged
              return res;
            }
          });
        });
      }
    }
  };

  const updatePositionAfterBetPlace = (type) => {
    if (type == "betFair") {
      // secureLocalStorage?.removeItem("betFair");
      // secureLocalStorage.setItem(
      //   "betFair",
      //   selections?.map((res) => {
      //     return {
      //       selectionId: res?.SelectionId,
      //       position: res?.newPosition,
      //     };
      //   })
      // );
      setPosition((prev) => {
        return {
          ...prev,
          betFair: selections?.map((res) => {
            return {
              selectionId: res?.SelectionId,
              position: res?.newPosition,
            };
          }),
        };
      });
      setSelections(
        selections?.map((res) => {
          return {
            ...res,
            position: res?.newPosition,
            newPosition: 0,
          };
        }),
      );
      setSelectionDemo(
        selections?.map((res) => {
          return {
            ...res,
            position: res?.newPosition,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "fancy") {
      // secureLocalStorage?.removeItem("fancy");
      // secureLocalStorage.setItem(
      //   "fancy",
      //   fancyList
      //     ?.filter((res) => {
      //       return (
      //         Math.abs(res?.position) > 0 || res?.selectionId == slipObj?.selectionId
      //       );
      //     })
      //     ?.map((res) => {
      //       if(res?.selectionId == slipObj?.selectionId){
      //         let newPosition = ''
      //         if (slipObj?.ib) {
      //           if (Math.abs(res?.position) > 0) {
      //             let backLoss = Number(betSelectionObj?.bidPrice) + Number(res.position);
      //             newPosition = Number(backLoss);
      //           } else {
      //             let backLoss = Number(betSelectionObj?.bidPrice);
      //             newPosition = Number(backLoss);
      //           }
      //         } else {
      //           if (Math.abs(res?.position) > 0) {
      //             let backProfit =
      //               (Number(betSelectionObj?.bidPrice) * Number(slipObj?.pt)) / 100;
      //               newPosition = (Number(backProfit) + Number(res.position));
      //           } else {
      //             let backProfit =
      //               (Number(betSelectionObj?.bidPrice) * Number(slipObj?.pt)) / 100;
      //             newPosition = (Number(backProfit));
      //           }
      //         }
      //         return {
      //           selectionId: res?.selectionId,
      //           position: newPosition,
      //         };
      //       } else {
      //         return {
      //           selectionId: res?.selectionId,
      //           position: res?.position,
      //         };
      //       }
      //     })
      // );
      // setFancyList((prev) => {
      //   return prev?.map((res) => {
      //     if(res?.selectionId == slipObj?.selectionId){
      //       let newPosition = ''
      //       if (slipObj?.ib) {
      //         if (Math.abs(res?.position) > 0) {
      //           let backLoss = Number(betSelectionObj?.bidPrice) + Number(res.position);
      //           newPosition = Number(backLoss);
      //         } else {
      //           let backLoss = Number(betSelectionObj?.bidPrice);
      //           newPosition = Number(backLoss);
      //         }
      //       } else {
      //         if (Math.abs(res?.position) > 0) {
      //           let backProfit =
      //             (Number(betSelectionObj?.bidPrice) * Number(slipObj?.pt)) / 100;
      //             newPosition = (Number(backProfit) + Number(res.position));
      //         } else {
      //           let backProfit =
      //             (Number(betSelectionObj?.bidPrice) * Number(slipObj?.pt)) / 100;
      //           newPosition = (Number(backProfit));
      //         }
      //       }
      //       return {
      //        ...res,
      //         position: newPosition
      //       };
      //     } else {
      //     return {
      //       ...res,
      //       position:res?.position
      //     }}
      //   });
      // });
      // setFancyCategoryTabArray((prev) => {
      //   return prev?.map((res) => {
      //     if(res?.selectionId == slipObj?.selectionId){
      //       let newPosition = ''
      //       if (slipObj?.ib) {
      //         if (Math.abs(res?.position) > 0) {
      //           let backLoss = Number(betSelectionObj?.bidPrice) + Number(res.position);
      //           newPosition = Number(backLoss);
      //         } else {
      //           let backLoss = Number(betSelectionObj?.bidPrice);
      //           newPosition = Number(backLoss);
      //         }
      //       } else {
      //         if (Math.abs(res?.position) > 0) {
      //           let backProfit =
      //             (Number(betSelectionObj?.bidPrice) * Number(slipObj?.pt)) / 100;
      //             newPosition = (Number(backProfit) + Number(res.position));
      //         } else {
      //           let backProfit =
      //             (Number(betSelectionObj?.bidPrice) * Number(slipObj?.pt)) / 100;
      //           newPosition = (Number(backProfit));
      //         }
      //       }
      //       return {
      //        ...res,
      //         position: newPosition
      //       };
      //     } else {
      //     return {
      //       ...res,
      //       position:res?.position
      //     }}
      //   });
      // });
    } else if (type == "bookmaker") {
      // secureLocalStorage?.removeItem("bookmaker");
      // secureLocalStorage.setItem(
      //   "bookmaker",
      //   bookmakerSelections?.map((res) => {
      //     return {
      //       selectionId: `B${res?.SelectionId}`,
      //       position: res?.newPosition,
      //     };
      //   })
      // );
      setPosition((prev) => {
        return {
          ...prev,
          bookmaker: bookmakerSelections?.map((res) => {
            return {
              selectionId: `B${res?.SelectionId}`,
              position: res?.newPosition,
            };
          }),
        };
      });
      setBookmakerSelections(
        bookmakerSelections?.map((res) => {
          return {
            ...res,
            position: res?.newPosition,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "tie") {
      // secureLocalStorage?.removeItem("tie");
      // secureLocalStorage.setItem(
      //   "tie",
      //   jsonTieData?.map((res) => {
      //     return {
      //       selectionId: res?.SelectionId,
      //       position: res?.newPosition,
      //     };
      //   })
      // );
      setJsonTieData(
        jsonTieData?.map((res) => {
          return {
            ...res,
            position: res?.newPosition,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "toss") {
      // secureLocalStorage?.removeItem("toss");
      // secureLocalStorage.setItem(
      //   "toss",
      //   tossList?.map((res) => {
      //     return {
      //       selectionId: res?.SelectionId,
      //       position: res?.newPosition,
      //     };
      //   })
      // );
      setTossList(
        tossList?.map((res) => {
          return {
            ...res,
            position: res?.newPosition,
            newPosition: 0,
          };
        }),
      );
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      if (betPlacedCheck && isBetPlaced == "placed") {
        console.log(betSelectionObj?.betType);
        if (betSelectionObj?.betType == "fancy") {
          getFancyBetPosition();
          // updatePositionAfterBetPlace(betSelectionObj?.betType)
          setBetPlacedCheck(false);
          setSlipObj({});
        } else if (
          betSelectionObj?.betType == "bookmaker" ||
          betSelectionObj?.betType == "betFair" ||
          betSelectionObj?.betType == "toss" ||
          betSelectionObj?.betType == "tie"
        ) {
          getBetPosition();
          // updatePositionAfterBetPlace(betSelectionObj?.betType);
          setBetPlacedCheck(false);
          setSlipObj({});
        } else if (betSelectionObj?.betType == "premiumFancy") {
          getPremiumFancyBetPosition();
          setBetPlacedCheck(false);
          setSlipObj({});
        }
      } else if (betPlacedCheck && isBetPlaced == "error") {
        resetSelection(betSelectionObj?.betType);
        setSlipObj({});
      }
    }
  }, [betPlacedCheck, isBetPlaced, updatePosition]);

  const resetPosition = (type) => {
    if (type == "betFair") {
      setSelections((current) =>
        position?.betFair?.length > 0
          ? current?.map((res) => {
              let obj = position?.betFair?.find(
                (item) => item.selectionId == res.SelectionId,
              );
              if (!isEmpty(obj)) {
                return {
                  ...res,
                  position:
                    obj.selectionId == res.SelectionId ? obj?.position : 0,
                  newPosition: 0,
                };
              } else {
                return {
                  ...res,
                  position: 0,
                  newPosition: 0,
                };
              }
            })
          : current.map((res) => {
              return {
                ...res,
                position: 0,
                newPosition: 0,
              };
            }),
      );
    } else if (type == "bookmaker") {
      setBookmakerSelections((current) =>
        position?.bookmaker?.length > 0
          ? current?.map((res) => {
              let obj = position?.bookmaker?.find(
                (item) => item?.selectionId == `B${res?.SelectionId}`,
              );
              return {
                ...res,
                position: obj?.position ? obj?.position : 0,
                newPosition: 0,
              };
            })
          : current?.map((res) => {
              return {
                ...res,
                position: 0,
                newPosition: 0,
              };
            }),
      );
    } else if (type == "sportBook") {
      setPremiumFancy((current) => {
        return premiumFancyPosition?.length > 0
          ? current?.map((res) => {
              let obj = premiumFancyPosition?.find(
                (item) =>
                  item?.fancyName == res?.marketName &&
                  res?.id == item?.marketId,
              );
              return obj?.marketId == res?.id &&
                obj?.fancyName == res?.marketName
                ? {
                    ...res,
                    sportsBookSelection: res?.sportsBookSelection?.map(
                      (temp) => {
                        return temp?.id == obj?.selectionId &&
                          temp?.selectionName == obj?.runnerName
                          ? {
                              ...temp,
                              position: obj?.profitAmount,
                              newPosition: 0,
                            }
                          : {
                              ...temp,
                              position: obj?.loseAmount,
                              newPosition: 0,
                            };
                      },
                    ),
                  }
                : res;
            })
          : current.map((res) => {
              return {
                ...res,
                sportsBookSelection: res?.sportsBookSelection?.map((item) => {
                  return { ...item, newPosition: 0 };
                }),
              };
            });
      });
    } else if (type == "toss") {
      setTossList((current) =>
        current.map((res) => {
          return {
            ...res,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "multi") {
      setMarketNew((current) =>
        current?.map((res) => {
          return {
            ...res,
            jsonData: res?.jsonData?.map((newObj) => {
              return {
                ...newObj,
                position: newObj?.position || 0,
                newPosition: 0,
              };
            }),
          };
        }),
      );
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      let obj = (
        details?.matchSetting?.length > 0
          ? details?.matchSetting
          : profileData?.matchSetting
      )?.find(
        (res) =>
          res?.type == "sportBook" &&
          (details?.matchSetting?.length > 0
            ? details?.matchSetting
            : profileData?.matchSetting
              ? true
              : res?.sportType == details?.gameType),
      );
      if (!isEmpty(obj)) {
        setMinSportBook(Number(obj?.minAmount));
      }
    }
  }, []);

  const resetSelection = (type) => {
    if (type == "betFair") {
      setSelectionDemo((current) =>
        current.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        }),
      );
      setSelections((current) =>
        current.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "bookmaker") {
      setBookmakerSelections((current) =>
        current?.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "premiumFancy") {
      setPremiumFancy((current) => {
        return premiumFancyPosition?.length > 0
          ? current?.map((res) => {
              let obj = premiumFancyPosition?.find(
                (item) =>
                  item?.fancyName == res?.marketName &&
                  res?.id == item?.marketId,
              );
              return obj?.marketId == res?.id &&
                obj?.fancyName == res?.marketName
                ? {
                    ...res,
                    sportsBookSelection: res?.sportsBookSelection?.map(
                      (temp) => {
                        return temp?.id == obj?.selectionId &&
                          temp?.selectionName == obj?.runnerName
                          ? {
                              ...temp,
                              position: obj?.profitAmount,
                              newPosition: 0,
                            }
                          : {
                              ...temp,
                              position: obj?.loseAmount,
                              newPosition: 0,
                            };
                      },
                    ),
                  }
                : res;
            })
          : current;
      });
    } else if (type == "tie") {
      setJsonTieData((current) =>
        current.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "toss") {
      setTossList((prev) => {
        return prev.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        });
      });
    } else if (type == "multi") {
      setMarketNew((current) =>
        current?.map((res) => {
          return {
            ...res,
            jsonData: res?.jsonData?.map((newObj) => {
              return {
                ...newObj,
                position: Math.abs(newObj?.position) > 0 ? newObj?.position : 0,
                newPosition: 0,
              };
            }),
          };
        }),
      );
    }
  };

  const handelBetFairPositions = (slipObj) => {
    let newselection = [...selections]?.map((res) => {
      return {
        ...res,
        position: res?.position || 0,
        newPosition: res?.newPosition || 0,
      };
    });
    let selectionsTemp = [...newselection];
    if (betSelectionObj?.bidPrice > 0) {
      if (slipObj.ib) {
        let backProfit =
          Number(betSelectionObj.oddsSelect - 1) *
          Number(betSelectionObj?.bidPrice); //(slipObj.rt - 1) * betSelectionObj?.bidPrice;
        let backLoss = Number(betSelectionObj?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setSelections(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              }
            }),
          );
        } else {
          setSelections(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj.ri) {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              }
            }),
          );
        }
      } else {
        let backProfit = Number(betSelectionObj?.bidPrice);
        let backLoss =
          Number(betSelectionObj.oddsSelect - 1) *
          Number(betSelectionObj?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setSelections(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              }
            }),
          );
        } else {
          setSelections(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj.ri) {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              }
            }),
          );
        }
      }
    }
  };

  const handelBookmakerPositions = (slipObj) => {
    let newselection = [...bookmakerSelections]?.map((res) => {
      return {
        ...res,
        position: res?.position || 0,
        newPosition: res?.newPosition || 0,
      };
    });
    if (betSelectionObj?.bidPrice >= 0) {
      if (slipObj.ib) {
        let backProfit = Number(
          (Number(slipObj?.rt) / 100) * Number(betSelectionObj?.bidPrice),
        );
        let backLoss = Number(betSelectionObj?.bidPrice);
        if (Math.abs(newselection[0]?.position) > 0) {
          setBookmakerSelections(
            newselection?.map((rl) => {
              if (rl.SelectionId == slipObj.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              }
            }),
          );
        } else {
          setBookmakerSelections(
            newselection?.map((rl) => {
              if (rl.SelectionId == slipObj.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              }
            }),
          );
        }
      } else {
        let backProfit = Number(betSelectionObj?.bidPrice);
        let backLoss = Number(
          (Number(slipObj?.rt) / 100) * Number(betSelectionObj?.bidPrice),
        );
        if (Math.abs(newselection[0]?.position) > 0) {
          setBookmakerSelections(
            newselection?.map((rl) => {
              if (rl.SelectionId == slipObj.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              }
            }),
          );
        } else {
          setBookmakerSelections(
            newselection?.map((rl) => {
              if (rl.SelectionId == slipObj.SelectionId) {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              }
            }),
          );
        }
      }
    }
  };

  const handelFancyPositions = (slipObj) => {
    if (betSelectionObj?.bidPrice >= 0) {
      if (slipObj.ib) {
        let currentPosition = fancyList.find(
          (rl) => rl.selectionId == slipObj.selectionId,
        );
        if (
          Math.abs(currentPosition.position) !== 0 &&
          !isEmpty(currentPosition.type)
        ) {
          let backLoss = betSelectionObj?.bidPrice + currentPosition.position;
          currentPosition.newPosition = backLoss;
          const result = fancyList.map((data) => {
            if (data.selectionId == currentPosition.selectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition).toFixed(2)
                : null;
            }
            return data;
          });
          setFancyCategoryTabArray(result);
          setFancyList(result);
        } else {
          let backLoss = betSelectionObj?.bidPrice;
          currentPosition.newPosition = backLoss;
          const result = fancyList.map((data) => {
            if (data.selectionId == currentPosition.selectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition).toFixed(2)
                : null;
            }
            return data;
          });
          setFancyCategoryTabArray(result);
          setFancyList(result);
        }
      } else {
        let currentPosition = fancyList.find(
          (rl) => rl?.selectionId == slipObj?.selectionId,
        );
        if (
          !isNaN(Math.abs(currentPosition?.position)) &&
          !isEmpty(currentPosition?.type)
        ) {
          let backProfit =
            (betSelectionObj?.bidPrice * betSelectionObj.fancyOddSelect) / 100;
          currentPosition.newPosition = backProfit + currentPosition.position;
          const result = fancyList.map((data) => {
            if (data.selectionId == currentPosition.selectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition).toFixed(2)
                : null;
            }
            return data;
          });
          setFancyCategoryTabArray(result);
          setFancyList(result);
        } else {
          let backProfit =
            (betSelectionObj?.bidPrice * betSelectionObj.fancyOddSelect) / 100;
          currentPosition.newPosition = backProfit;
          const result = fancyList.map((data) => {
            if (data.selectionId == currentPosition.selectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition).toFixed(2)
                : null;
            }
            return data;
          });
          // console.log("result",result);
          setFancyCategoryTabArray(result);
          setFancyList(result);
        }
      }
    }
  };

  const handelPreminumFancyPositions = (slipObj) => {
    if (betSelectionObj?.bidPrice >= 0) {
      let backProfit =
        (betSelectionObj.oddsSelect - 1) * betSelectionObj?.bidPrice;
      let backLoss = betSelectionObj?.bidPrice;
      setPremiumFancy((current) => {
        return current?.map((rl) =>
          rl?.id === slipObj?.newMarketId
            ? {
                ...rl,
                sportsBookSelection: rl?.sportsBookSelection?.map((res) => {
                  return res.id === slipObj.selectId
                    ? {
                        ...res,
                        position:
                          res.position !== 0 && !isNaN(Math.abs(res.position))
                            ? res.position
                            : 0,
                        newPosition:
                          res.position !== 0 && !isNaN(Math.abs(res.position))
                            ? Number(backProfit) + Number(res.position)
                            : Number(backProfit),
                      }
                    : {
                        ...res,
                        position:
                          res.position !== 0 && !isNaN(Math.abs(res.position))
                            ? res.position
                            : 0,
                        newPosition:
                          res.position !== 0 && !isNaN(Math.abs(res.position))
                            ? Number(backLoss) - Number(res.position)
                            : -Number(backLoss),
                      };
                }),
              }
            : rl,
        );
      });
      // setPremiumFancy((current) => {
      //   return current?.map((rl) =>
      //     rl.marketId === slipObj.marketId
      //       ? {
      //           ...rl,
      //           runners: rl.runners?.map((res) => {
      //             return res.runnerId === slipObj.selectId
      //               ? {
      //                   ...res,
      //                   position:
      //                     res.position !== 0 && !isNaN(Math.abs(res.position))
      //                       ? res.position
      //                       : 0,
      //                   newPosition:
      //                     res.position !== 0 && !isNaN(Math.abs(res.position))
      //                       ? Number(backProfit) + Number(res.position)
      //                       : Number(backProfit),
      //                 }
      //               : {
      //                   ...res,
      //                   position:
      //                     res.position !== 0 && !isNaN(Math.abs(res.position))
      //                       ? res.position
      //                       : 0,
      //                   newPosition:
      //                     res.position !== 0 && !isNaN(Math.abs(res.position))
      //                       ? Number(backLoss) - Number(res.position)
      //                       : -Number(backLoss),
      //                 };
      //           }),
      //         }
      //       : rl
      //   );
      // });
    }
  };

  const tossPosition = (slipObj) => {
    if (betSelectionObj?.bidPrice >= 0) {
      let temp = [...tossList].map((res) => {
        return {
          ...res,
          newPosition: res?.newPosition || 0,
          position: res?.position || 0,
        };
      });
      let backProfit =
        Number(betSelectionObj.oddsSelect - 1) *
        Number(betSelectionObj?.bidPrice); //(slipObj.rt - 1) * betSelectionObj?.bidPrice;
      let backLoss = Number(betSelectionObj?.bidPrice);
      if (Math.abs(temp[0]?.position) > 0) {
        setTossList(
          temp?.map((res) => {
            if (res.SelectionId == slipObj.SelectionId) {
              return {
                ...res,
                newPosition: Number(res.position) + backProfit,
              };
            } else {
              return {
                ...res,
                newPosition: Number(res.position) - backLoss,
              };
            }
          }),
        );
      } else {
        setSelections(
          temp?.map((rl) => {
            if (rl.SelectionId == slipObj.SelectionId) {
              return {
                ...rl,
                newPosition: Number(backProfit),
              };
            } else {
              return {
                ...rl,
                newPosition: -Number(backLoss),
              };
            }
          }),
        );
      }
    }
  };

  const handelTiePosition = (slipObj) => {
    let temp = [...jsonTieData];
    if (betSelectionObj?.bidPrice > 0) {
      if (slipObj.ib) {
        let currentPosition = temp.find((rl) => rl.SelectionId == slipObj.ri);
        let otherTeamPosition;
        let thirdTeamPosition;
        if (slipObj.RunnerName == "The Draw") {
          otherTeamPosition = temp[0];
          thirdTeamPosition = temp[1];
        } else {
          otherTeamPosition = temp.find(
            (rl) =>
              rl.SelectionId !== slipObj.ri && rl.RunnerName != "The Draw",
          );
          thirdTeamPosition = temp[2] ? temp[2] : false;
        }
        let backProfit =
          (betSelectionObj.oddsSelect - 1) * betSelectionObj?.bidPrice; //(slipObj.rt - 1) * betSelectionObj?.bidPrice;
        let backLoss = betSelectionObj?.bidPrice;
        if (
          Math.abs(temp[0]?.position) !== 0 &&
          Math.abs(temp[1]?.position) !== 0
        ) {
          currentPosition.newPosition = currentPosition.position + backProfit;
          otherTeamPosition.newPosition = otherTeamPosition.position - backLoss;
          if (thirdTeamPosition) {
            thirdTeamPosition.newPosition =
              thirdTeamPosition.position - backLoss;
          }
          const result = temp.map((data) => {
            if (data.SelectionId == currentPosition.SelectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition.toFixed(2))
                : 0;
            }
            if (data.SelectionId == otherTeamPosition.SelectionId) {
              data.newPosition = otherTeamPosition?.newPosition
                ? parseFloat(otherTeamPosition?.newPosition.toFixed(2))
                : 0;
            }
            if (
              thirdTeamPosition &&
              data.SelectionId == thirdTeamPosition.SelectionId
            ) {
              data.newPosition = thirdTeamPosition?.newPosition
                ? parseFloat(thirdTeamPosition?.newPosition.toFixed(2))
                : 0;
            }
            return data;
          });
          setJsonTieData(result);
        } else {
          currentPosition.newPosition = backProfit;
          otherTeamPosition.newPosition = -backLoss;
          if (thirdTeamPosition) {
            thirdTeamPosition.newPosition = -backLoss;
          }
          const result = temp.map((data) => {
            if (data.SelectionId == currentPosition.SelectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition.toFixed(2))
                : 0;
            }
            if (data.SelectionId == otherTeamPosition.SelectionId) {
              data.newPosition = otherTeamPosition?.newPosition
                ? parseFloat(otherTeamPosition?.newPosition.toFixed(2))
                : 0;
            }
            if (
              thirdTeamPosition &&
              data.SelectionId == thirdTeamPosition.SelectionId
            ) {
              data.newPosition = thirdTeamPosition?.newPosition
                ? parseFloat(thirdTeamPosition?.newPosition.toFixed(2))
                : 0;
            }
            return data;
          });
          setJsonTieData(result);
        }
      } else {
        let currentPosition = temp.find((rl) => rl.SelectionId == slipObj.ri);
        let otherTeamPosition;
        let thirdTeamPosition;
        if (slipObj.RunnerName == "The Draw") {
          otherTeamPosition = temp[0];
          thirdTeamPosition = temp[1];
        } else {
          otherTeamPosition = temp.find(
            (rl) =>
              rl.SelectionId !== slipObj.ri && rl.RunnerName != "The Draw",
          );
          thirdTeamPosition = temp[2] ? temp[2] : false;
        }
        if (
          Math.abs(currentPosition?.position) !== 0 &&
          Math.abs(currentPosition?.position) !== 0
        ) {
          let backProfit = betSelectionObj?.bidPrice;
          let backLoss =
            (betSelectionObj.oddsSelect - 1) * betSelectionObj?.bidPrice; //(slipObj.rt - 1) * betSelectionObj?.bidPrice;
          currentPosition.newPosition =
            Number(currentPosition?.position) - Number(backLoss);
          otherTeamPosition.newPosition =
            Number(otherTeamPosition?.position) + Number(backProfit);
          if (thirdTeamPosition) {
            thirdTeamPosition.newPosition =
              Number(thirdTeamPosition?.position) + Number(backProfit);
          }
          const result = temp.map((data) => {
            if (data?.SelectionId == currentPosition?.SelectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition)
                : 0;
            }
            if (data?.SelectionId == otherTeamPosition?.SelectionId) {
              data.newPosition = otherTeamPosition?.newPosition
                ? parseFloat(otherTeamPosition?.newPosition)
                : 0;
            }
            if (
              thirdTeamPosition &&
              data?.SelectionId == thirdTeamPosition?.SelectionId
            ) {
              data.newPosition = thirdTeamPosition?.newPosition
                ? parseFloat(thirdTeamPosition?.newPosition)
                : 0;
            }
            return data;
          });
          setJsonTieData(result);
        } else {
          let backProfit = betSelectionObj?.bidPrice;
          let backLoss =
            (betSelectionObj.oddsSelect - 1) * betSelectionObj?.bidPrice; //(slipObj.rt - 1) * betSelectionObj?.bidPrice
          currentPosition.newPosition = -Number(backLoss);
          otherTeamPosition.newPosition = Number(backProfit);
          if (thirdTeamPosition) {
            thirdTeamPosition.newPosition = Number(backProfit);
          }
          const result = temp.map((data) => {
            if (data?.SelectionId == currentPosition?.SelectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition)
                : 0;
            }
            if (data?.SelectionId == otherTeamPosition?.SelectionId) {
              data.newPosition = otherTeamPosition?.newPosition
                ? parseFloat(otherTeamPosition?.newPosition)
                : 0;
            }
            if (
              thirdTeamPosition &&
              data?.SelectionId == thirdTeamPosition?.SelectionId
            ) {
              data.newPosition = thirdTeamPosition?.newPosition
                ? parseFloat(thirdTeamPosition?.newPosition)
                : 0;
            }
            return data;
          });
          setJsonTieData(result);
        }
      }
    }
  };

  const updatedFancyPosition = (object) => {
    setFancyPosition(object);
    setFancyList((prev) => {
      return prev?.map((res) => {
        let obj = object?.find((item) => item.selectionId == res.selectionId);
        return {
          ...res,
          odds: res,
          position: !isEmpty(obj) ? obj?.position : "",
        };
      });
    });
    setFancyCategoryTabArray((prev) => {
      return prev?.map((res) => {
        let obj = object?.find((item) => item.selectionId == res.selectionId);
        return {
          ...res,
          odds: res,
          position: !isEmpty(obj) ? obj?.position : "",
        };
      });
    });
  };

  const updatePositionNew = (object) => {
    setTempSelection(object?.betFair);
    setSelectionDemo((current) =>
      object?.betFair?.length > 0
        ? current.map((res) => {
            let obj = object?.betFair.find(
              (item) => item?.selectionId == res?.SelectionId,
            );
            if (!isEmpty(obj)) {
              return {
                ...res,
                position:
                  obj?.selectionId == res?.SelectionId ? obj?.position : 0,
                newPosition: 0,
              };
            } else {
              return {
                ...res,
                position: 0,
                newPosition: 0,
              };
            }
          })
        : current.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
    setSelections((current) =>
      object?.betFair?.length > 0
        ? current.map((res) => {
            let obj = object?.betFair.find(
              (item) => item?.selectionId == res?.SelectionId,
            );
            if (!isEmpty(obj)) {
              return {
                ...res,
                position:
                  obj?.selectionId == res?.SelectionId ? obj?.position : 0,
                newPosition: 0,
              };
            } else {
              return {
                ...res,
                position: 0,
                newPosition: 0,
              };
            }
          })
        : current.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
    setBookmakerSelections((current) =>
      object?.bookmaker?.length > 0
        ? current?.map((res) => {
            let obj = object?.bookmaker?.find(
              (item) => item?.selectionId == res?.SelectionId,
            );
            return {
              ...res,
              position: obj?.position ? obj?.position : 0,
              newPosition: 0,
            };
          })
        : current?.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
    setJsonTieData((current) =>
      object?.tie?.length > 0
        ? current?.map((res) => {
            let obj = object?.tie?.find(
              (item) => item?.selectionId == res?.SelectionId,
            );
            return {
              ...res,
              position:
                obj?.selectionId == res?.SelectionId ? obj?.position : 0,
              newPosition: 0,
            };
          })
        : current?.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
    setTossList((current) =>
      object?.toss?.length > 0
        ? current?.map((res) => {
            let obj = object?.toss?.find(
              (item) => item?.selectionId == res?.SelectionId,
            );
            return {
              ...res,
              position:
                obj?.selectionId == res?.SelectionId ? obj?.position : 0,
              newPosition: 0,
            };
          })
        : current?.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (!isEmpty(user)) {
  //       if (!isEmpty(details)) {
  //         startTransition(() => {
  //           if (
  //             !(
  //               secureLocalStorage.getItem("betFair") ||
  //               secureLocalStorage.getItem("bookmaker")
  //             )
  //           ) {
  //             getBetPosition();
  //           } else {
  //             let obj = {
  //               betFair:
  //                 secureLocalStorage.getItem("betFair")?.length > 0
  //                   ? secureLocalStorage.getItem("betFair")
  //                   : [],
  //               bookmaker:
  //                 secureLocalStorage.getItem("bookmaker")?.length > 0
  //                   ? secureLocalStorage.getItem("bookmaker")
  //                   : [],
  //               tie:
  //                 secureLocalStorage.getItem("tie")?.length > 0
  //                   ? secureLocalStorage.getItem("tie")
  //                   : [],
  //               toss:
  //                 secureLocalStorage.getItem("toss")?.length > 0
  //                   ? secureLocalStorage.getItem("toss")
  //                   : [],
  //             };
  //             updatePositionNew(obj);
  //           }
  //           getFancyBetPosition();
  //           if (!secureLocalStorage.getItem("premiumFancy")) {
  //             getPremiumFancyBetPosition();
  //           }
  //         });
  //       }
  //     }
  //   }, 2000);
  // }, [details]);

  useEffect(() => {
    setTimeout(() => {
      if (!isEmpty(user)) {
        if (!isEmpty(details)) {
          startTransition(() => {
            getBetPosition();
            getFancyBetPosition();
            if (hasPremiumFancy) {
              getPremiumFancyBetPosition();
            }
          });
        }
      }
    }, 500);
  }, [details]);

  useEffect(() => {
    if (
      !isEmpty(slipObj) &&
      betSelectionObj?.betType == "betFair" &&
      betSelectionObj?.bidPrice > 0
    ) {
      handelBetFairPositions(slipObj);
    } else if (
      !isEmpty(slipObj) &&
      betSelectionObj?.betType == "bookmaker" &&
      betSelectionObj?.bidPrice > 0
    ) {
      handelBookmakerPositions(slipObj);
    } else if (
      !isEmpty(slipObj) &&
      betSelectionObj?.betType == "fancy" &&
      betSelectionObj?.bidPrice > 0
    ) {
      handelFancyPositions(slipObj);
    } else if (
      !isEmpty(slipObj) &&
      betSelectionObj?.betType == "premiumFancy" &&
      betSelectionObj?.bidPrice > 0
    ) {
      handelPreminumFancyPositions(slipObj);
    } else if (
      !isEmpty(slipObj) &&
      betSelectionObj?.priceToogleType == "toss" &&
      betSelectionObj?.betType == "toss" &&
      betSelectionObj?.bidPrice > 0
    ) {
      tossPosition(slipObj);
    } else if (
      !isEmpty(slipObj) &&
      betSelectionObj?.priceToogleType == "odds" &&
      betSelectionObj?.betType == "tie" &&
      betSelectionObj?.bidPrice > 0
    ) {
      handelTiePosition(slipObj);
    }
  }, [
    betSelectionObj?.bidPrice,
    slipObj,
    betSelectionObj?.oddsSelect,
    betSelectionObj?.betType,
  ]);

  let header1 = document.getElementById("headerMain1")
    ? Number(document.getElementById("headerMain1")?.offsetHeight)
    : 0;
  let header2 = document.getElementById("headerMain2")
    ? Number(document.getElementById("headerMain2")?.offsetHeight)
    : 0;
  let videoFrame = document?.getElementById("videoFrame")?.offsetHeight
    ? Number(document?.getElementById("videoFrame")?.offsetHeight)
    : 0;

  useEffect(() => {
    const check = () => {
      if (pop && y >= 280 && isTv?.status && isTv?.id !== "") {
        return header1 + header2 + videoFrame;
      } else if (isTv?.status && isTv?.id !== "") {
        return header1 + header2 + videoFrame;
      } else {
        return header1 + header2;
      }
    };
    let temp = check();
    if (!isEmpty(user)) {
      var allElements = document.getElementsByTagName("*");
      for (var i = 0, len = allElements.length; i < len; i++) {
        var element = allElements[i];
        element.style.scrollMarginTop = `${temp}px`;
      }
    }
    if (key == "Fancy Bet") {
      if (
        fancyCategoryTabArray?.filter((res) => res.odds?.rt?.length > 0)
          ?.length > 7
      ) {
        setPop(true);
      } else {
        setPop(false);
      }
    } else if (key == "Preminum Fancy") {
      if (preminumFancy?.length >= 12) {
        setPop(true);
      } else {
        setPop(false);
      }
    }
  }, [y, key, details, preminumFancy, fancyList, betSelectionObj]);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPosition]);

  let timeDiff = moment.duration(
    moment(details.eventDateTime).diff(moment(new Date())),
  )?._data;
  let temp =
    timeDiff?.days <= 0 &&
    timeDiff?.hours <= 1 &&
    timeDiff?.years <= 0 &&
    timeDiff?.months <= 0 &&
    timeDiff?.minutes <= 5;

  useEffect(() => {
    const timeoutID = window.setTimeout(() => {
      setControls(false);
    }, 4000);
    return () => window.clearTimeout(timeoutID);
  }, [controls]);

  useEffect(() => {
    if (isTv?.status) {
      setControls(true);
    }
  }, [isTv]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowInplaySlip(true);
    }, 500);
    return () => clearTimeout(timer);
  }, [details?.status, totalMatched]);

  let tabPosition = {
    cricket: "bottom",
    tennis: "top",
    soccer: "bottom",
  };

  const displayScore = () => {
    return details?.gameType == "soccer" ? (
      <LiveMatchTrackerSoccer
        type="inner"
        tabPosition={tabPosition[details?.gameType]}
        scoreId={details?.scoreId}
      />
    ) : details?.gameType == "tennis" ? (
      <LiveMatchTrackerTennis
        type="inner"
        tabPosition={tabPosition[details?.gameType]}
        scoreId={details?.scoreId}
      />
    ) : (
      <LiveMatchTrackerCricket
        type="inner"
        tabPosition={tabPosition[details?.gameType]}
        scoreId={details?.scoreId}
      />
    );
  };

  useEffect(() => {
    if (hasFancy && location?.state?.gameType === "cricket") {
      setKey("Fancy Bet");
    } else {
      setKey("Preminum Fancy");
    }
  }, []);
  // console.log(details?.status)
  return (
    <LayoutComponent visibilityType={true}>
      <>
        <div id="mainWrap" className="mainWrap">
          {!isEmpty(user) &&
          details?.eventId > 0 &&
          Object.keys(slipObj).length === 0 &&
          details?.status == "in_play" ? (
            isTv?.id !== "false" && isTv?.status ? (
              <>
                <div
                  className={
                    pop && y >= 280 ? "is-outside vedio_wrap" : "vedio_wrap"
                  }
                >
                  {controls && (
                    <div className="tv-control vedio_up_icon">
                      <a
                        class="close"
                        id="closeStreamingBox"
                        href="javascript:void(0)"
                        onClick={() => {
                          setIsTv({ ...isTv, status: false });
                          setSeek(true);
                        }}
                        style={{ display: "flex" }}
                      >
                        Close
                      </a>
                    </div>
                  )}
                  {pop && y >= 280
                    ? ""
                    : controls && (
                        <div
                          className="tv-control vedio_up_icon"
                          style={{ marginBottom: "20px" }}
                        >
                          <a
                            class={mute ? "btn-volume_off" : "btn-volume_on"}
                            onClick={() => setMute(!mute)}
                            href="javascript:void(0)"
                            id="mute"
                          >
                            {mute ? "Mute Off" : "Mute On"}
                          </a>
                          <a
                            className="btn-line"
                            href="javascript:void(0)"
                            id="changeLineBtn"
                          >
                            <span id="tvLine">4</span>
                          </a>
                        </div>
                      )}

                  {/* Alternative TV - Iframe (Glive TV) */}
                  {/* {isGliveTv && ( */}
                  {/* {!isEmpty(details?.tvURL) && (*/}
                  <>
                    {!iframeLoaded && (
                      <img
                        src={LoadingImage}
                        alt="Loading..."
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          zIndex: 1,
                        }}
                      />
                    )}
                    <iframe
                      // src={`https://app.livetvapi.com/event-play-2/${parmas?.eventId}`}
                      // src={details?.tvURL}
                      src={`https://ofa247.live/fairplay247/dtvp.html?id=${parmas?.eventId}`}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      allowFullScreen
                      referrerPolicy="origin"
                      onLoad={() => setIframeLoaded(true)}
                      style={{
                        minHeight: "57vw",
                        opacity: iframeLoaded ? 1 : 0,
                        transition: "opacity 0.3s ease",
                        backgroundColor: "#fff",
                      }}
                    />
                  </>
                  {/* )}*/}

                  {/* Alternative TV - ReactPlayer (m3u8 stream) */}
                  {/* {!isGliveTv && details?.streamingChannel && (
                    <>
                      {!gliveTvLoaded && (
                        <img
                          src={LoadingImage}
                          alt="Loading..."
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            zIndex: 1,
                          }}
                        />
                      )}
                      <ReactPlayer
                        muted={mute}
                        controls={controls}
                        ref={ref}
                        playsinline={true}
                        loop={true}
                        playing={true}
                        id="videoFrame"
                        style={{
                          overflowX: "hidden",
                          overflow: "hidden",
                          backgroundColor: "#000000",
                          minHeight: "57vw",
                        }}
                        onClick={() => setControls(true)}
                        width="100%"
                        height="57vw"
                        url={
                          details?.adsStatus
                            ? details?.adsContent
                            : `https://aax-eu1314.com/${details.streamingChannel}/index.m3u8`
                        }
                        config={{
                          file: {
                            attributes: {
                              preload: "none",
                            },
                            hlsOptions: {
                              startLevel: 3,
                            },
                          },
                        }}
                        onReady={() => setGliveTvLoaded(true)}
                      />
                    </>
                  )}*/}
                </div>
                {pop && y >= 280 && <div style={{ minHeight: "57vw" }}></div>}
              </>
            ) : (
              ""
            )
          ) : (
            ""
          )}
          <div className="game-wrap">
            <h4 id="gameInfo" class="game-info">
              {obj?.matchType &&
                details?.gameType &&
                obj?.matchType[details?.gameType] && (
                  <>
                    <span>{obj?.matchType[details?.gameType]}</span>
                    {showInplaySlip && (
                      <ul id="infoIcon" class="info-icon">
                        {/* {details?.status == "in_play" &&
  totalMatched > 10000 ? ( */}
                        <li id="inPlayIcon">
                          <img
                            className="info-inplay"
                            src={"/assets/images/home/transparent.gif"}
                          />
                          In-Play
                        </li>{" "}
                        {/* <li style={{ background: "green" }} id="inQuality">
  {totalMatched > 10000 ? "High" : ""}
  </li> */}
                        {/* // ) : (
  //   <li id="inQuality">
  //     {totalMatched < 10000 ? "Low" : ""}
  //   </li>
  // )}
  */}
                      </ul>
                    )}
                  </>
                )}
            </h4>
            {/* {!isEmpty(details?.scoreId) &&
  details?.scoreId != "false" &&
  (details.isCustomUrl && details.isCustomUrl == true ? (
  <div id="matchTrackerWrap" className="match-tracker-wrap">
  <iframe
  className="responsive-iframe w-100"
  style={{
  overflow: "hidden",
  height: "142px",
  backgroundColor: "#000000",
  }}
  id="scoreId"
  src={details?.scoreURL}
  ></iframe>
  </div>
  ) : ( */}
            {(scorecard || details?.scoreURL2) && (
              <iframe
                className="responsive-iframe w-100"
                style={{
                  overflow: "hidden",
                  height: "180px",
                  backgroundColor: "#000000",
                }}
                id="scoreId"
                src={scorecard || details?.scoreURL2}
              ></iframe>
            )}
            {/*  ))} */}
            <ul
              class="match-btn"
              style={{ paddingBottom: "10px", marginBottom: "0" }}
            >
              <li>
                <a
                  onClick={() => {
                    if (isEmpty(user)) {
                      navigate("/login");
                    } else {
                      handelAddMultiMarket(parmas?.eventId);
                    }
                  }}
                  id="liveMultiMarketPin"
                  href="javascript:void(0)"
                  className={
                    !isEmpty(
                      details?.multiMarkets?.find((res) => {
                        return res?.multiType == "match_odds";
                      }),
                    )
                      ? "btn-pin select"
                      : "btn-pin"
                  }
                >
                  Pin
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0)"
                  class="btn-refresh"
                  onClick={() => {
                    getMatchDetails();
                  }}
                >
                  Refresh
                </a>
              </li>
            </ul>
          </div>
          {!parly ? (
            <>
              {/* {console.log(marketNew)} */}
              {details?.matchOdds == "on" &&
                (selections?.length > 0 || marketNew?.length > 0) &&
                back_odds?.length > 0 &&
                back_odds?.length > 0 && (
                  <div
                    id="naviMarket"
                    className="market-type ps ps--theme_default"
                  >
                    <ul id="naviMarketList">
                      {marketNew?.length > 0
                        ? marketNew?.map((res) => {
                            return (
                              <li
                                className={
                                  res?.marketId === parmas?.marketId
                                    ? "select"
                                    : ""
                                }
                                // onClick={() => {
                                //   console.log(res?.marketId,'res?.marketId')
                                //   navigate(
                                //     `/match-details/${parmas?.eventId}/${res?.marketId}`
                                //   );
                                //   setSelections(res?.jsonData || []);
                                //   setTempSelection(res?.jsonData || []);
                                //   getMatchData(res?.marketId);
                                //   getBetPosition(res?.marketId);
                                //   setMarketName(res?.market)
                                // }}
                              >
                                <a href="#">{res?.market}</a>
                              </li>
                            );
                          })
                        : selections?.length > 0 &&
                          back_odds?.length > 0 &&
                          back_odds?.length > 0 && (
                            <li
                              id="naviMarket_1_207539177"
                              // onClick={() => {
                              //   setTab("match");
                              //   resetSelection("tie");
                              //   setBetSelectionObj({});
                              //   setSlipObj({});
                              // }}
                              className={tab === "match" ? "select" : ""}
                            >
                              <a href="#">Match Odds</a>
                            </li>
                          )}
                      {/* {jsonTieData?.length > 0 && (
                        <li
                          id="naviMarket_1_207539177"
                          onClick={() => {
                            setTab("tie");
                            resetSelection("betFair");
                            setBetSelectionObj({});
                            setSlipObj({});
                          }}
                          className={tab === "tie" ? "select" : ""}
                        >
                          <a href="#">Tie Match</a>
                        </li>
                      )} */}
                    </ul>
                  </div>
                )}
              {
                // details?.hasMatchOdds &&
                selections?.length > 0 &&
                  back_odds?.length > 0 &&
                  back_odds.filter((el) => el?.rt !== 0)?.length > 0 &&
                  lay_odds.filter((el) => el?.rt !== 0)?.length > 0 && (
                    <MatchDetails
                      selections={selections}
                      back_odds={back_odds}
                      betFairMs={betFairMs}
                      lay_odds={lay_odds}
                      messaageBox={messaageBox}
                      details={details}
                      totalMatched={totalMatched}
                      setSlipObj={setSlipObj}
                      setMarketDepth={setMarketDepth}
                      marketName={marketName}
                      tempSelection={tempSelection}
                      setSelections={setSelections}
                      slipObj={slipObj}
                      user={user}
                      loader={loader}
                      setLoader={setLoader}
                      betType={"betFair"}
                      handelBetFairPositions={handelBetFairPositions}
                      marketId={parmas?.marketId}
                      resetSelection={resetSelection}
                      setCondi={setCondi}
                      profileData={
                        details?.matchSetting?.length > 0
                          ? { ...details, arrayCheck: "details" }
                          : { ...profileData, arrayCheck: "profile" }
                      }
                    />
                  )
              }
              {hasBookmaker && (
                <Bookmaker
                  betType="bookmaker"
                  data={bookmakerSelections}
                  bookmakerObj={bookmakerData}
                  details={details}
                  back_odds={bookmakerBackOdds || []}
                  lay_odds={bookmakerLayOdds || []}
                  setSlipObj={setSlipObj}
                  handelBookmakerPositions={handelBookmakerPositions}
                  slipObj={slipObj}
                  messaageBox={messaageBox}
                  resetSelection={resetSelection}
                  profileData={
                    details?.matchSetting?.length > 0
                      ? { ...details, arrayCheck: "details" }
                      : { ...profileData, arrayCheck: "profile" }
                  }
                  user={user}
                  bottomSpaceClass={
                    !hasFancy && !hasPremiumFancy ? "default-bookmaker" : ""
                  }
                />
              )}
              {moment(new Date()).isBefore(
                moment(details.eventDateTime).subtract(60, "m").toDate(),
              ) &&
                details?.isTossEnable &&
                details?.matchOdds == "on" &&
                selections?.length > 0 &&
                back_odds?.length > 0 &&
                back_odds.filter((el) => el?.rt !== 0).length > 0 &&
                lay_odds.filter((el) => el?.rt !== 0).length > 0 &&
                back_oddsToss?.length > 0 &&
                details?.gameType == "cricket" && (
                  <Toss
                    betType="toss"
                    data={tossList}
                    // bookmakerObj={bookmakerData}
                    details={details}
                    back_odds={back_oddsToss || []}
                    tossObj={tossObj || []}
                    setSlipObj={setSlipObj}
                    handelBookmakerPositions={tossPosition}
                    slipObj={slipObj}
                    messaageBox={messaageBox}
                    resetSelection={resetSelection}
                    profileData={
                      details?.matchSetting?.length > 0
                        ? { ...details, arrayCheck: "details" }
                        : { ...profileData, arrayCheck: "profile" }
                    }
                    user={user}
                    bottomSpaceClass={
                      !hasFancy && !hasPremiumFancy ? "default-bookmaker" : ""
                    }
                    // handelBetFairPositions={handelBetFairPositions}
                  />
                )}
              {/* Fancy Listing  */}
              {/* {console.log(details)} */}
              {!hasFancy && !hasPremiumFancy ? (
                ""
              ) : (
                // ( fancyList?.length > 0 || preminumFancy?.length > 0) ? (
                <div
                  id={
                    key == "Fancy Bet"
                      ? "fancyBetTable_32011225"
                      : "sportsBookWrap"
                  }
                  style={{
                    display: "block",
                    marginBottom:
                      fancyCategoryTabArray?.filter(
                        (res) => res?.odds?.rt?.length > 0,
                      )?.length > 0 || preminumFancy?.length > 0
                        ? "210px"
                        : "210px",
                    background: "#e0e6e",
                  }}
                >
                  <div
                    id={key == "Fancy Bet" ? "fancyBetHead" : "sportsBookHead"}
                    className={
                      key == "Fancy Bet"
                        ? "fancy_bet-head"
                        : "sportsbook_bet-head"
                    }
                  >
                    {key == "Fancy Bet" && (
                      <a
                        id="multiMarketPin"
                        title="Add to Multi Markets"
                        className="pin-off"
                      >
                        Pin to Muilti Markets
                      </a>
                    )}
                    <h4
                      className="in-play"
                      onClick={() => {
                        setKey(
                          key == "Fancy Bet" ? "Fancy Bet" : "Preminum Fancy",
                        );
                        setPopupMessage(false);
                      }}
                      style={{ margin: "0" }}
                    >
                      {/* {console.log("--------------------->",key)} */}
                      {key == "Fancy Bet" && hasFancy ? (
                        <>
                          <span>
                            <pre>in-play</pre>
                            Fancy Bet
                          </span>
                          <a
                            href="javascript:void(0)"
                            onClick={() => {
                              key == "Fancy Bet"
                                ? setFancyRules(true)
                                : setPremiumFancyRules(true);
                              setPopupMessage(false);
                            }}
                            className="btn-head_rules"
                          >
                            Rules
                          </a>
                        </>
                      ) : (
                        hasPremiumFancy && (
                          <>
                            <span>
                              <pre>in-play</pre>
                              Preminum Fancy
                            </span>
                            <a
                              href="javascript:void(0)"
                              onClick={() => {
                                key == "Fancy Bet"
                                  ? setFancyRules(true)
                                  : setPremiumFancyRules(true);
                                setPopupMessage(false);
                              }}
                              className="btn-head_rules"
                            >
                              Rules
                            </a>
                          </>
                        )
                      )}
                    </h4>
                    {key == "Fancy Bet" ? (
                      hasPremiumFancy ? (
                        <a
                          href="javascript:void(0)"
                          id="showSportsBookBtn"
                          onClick={() => {
                            setKey("Preminum Fancy");
                            setPopupMessage(false);
                          }}
                          className="other-tab"
                        >
                          Preminum Fancy
                        </a>
                      ) : (
                        ""
                      )
                    ) : details?.gameType == "cricket" && hasFancy ? (
                      <a
                        href="javascript:void(0)"
                        id="showSportsBookBtn"
                        onClick={() => {
                          setKey("Fancy Bet");
                          setPopupMessage(false);
                        }}
                        className="other-tab"
                      >
                        Fancy Bet
                      </a>
                    ) : (
                      ""
                    )}
                    {key == "Preminum Fancy" && !isEmpty(user) && (
                      <>
                        <a
                          id="minMaxBtn_2"
                          onClick={() => setPopupMessage(true)}
                          href="javascript:void(0)"
                          class="btn-fancy_info"
                        >
                          Min
                        </a>
                        {popupMessage && (
                          <div
                            id="minMaxWrap_2"
                            class="fancy_info-popup"
                            style={{ display: "flex" }}
                          >
                            <dl>
                              <dt>Min</dt>
                              <dd id="minMaxInfo_2">{minSportBook}</dd>
                            </dl>
                            <a
                              href="javascript:void(0)"
                              onClick={() => setPopupMessage(false)}
                              class="close"
                            >
                              Close
                            </a>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  {/* {console.log("fancy",fancyCategoryTabArray)} */}
                  {/* {console.log(key)} */}
                  {key == "Fancy Bet" && hasFancy ? (
                    <Fancy
                      betType="fancy"
                      data={fancyCategoryTabArray || []}
                      details={details}
                      fancyList={fancyList || []}
                      back_odds={[]}
                      lay_odds={[]}
                      setSlipObj={setSlipObj}
                      isTv={isTv}
                      resetSelection={resetSelection}
                      slipObj={slipObj}
                      key={key}
                      loader={loader}
                      messaageBox={messaageBox}
                      setIsTv={setIsTv}
                      fancyCategory={fancyCategory}
                      setSelectedTabFunc={setSelectedTabFunc}
                      selectedTab={selectedTab}
                      profileData={
                        details?.matchSetting?.length > 0
                          ? { ...details, arrayCheck: "details" }
                          : { ...profileData, arrayCheck: "profile" }
                      }
                      user={user}
                    />
                  ) : key == "Preminum Fancy" && hasPremiumFancy ? (
                    <PremiumFancyNew
                      preminumFancyTab={preminumFancyTab}
                      setSelectedTabFuncPreminum={[]}
                      data={preminumFancy || []}
                      betType={"premiumFancy"}
                      setSlipObj={setSlipObj}
                      setPremiumFancy={setPremiumFancy}
                      slipObj={slipObj}
                      resetSelection={resetSelection}
                      key={key}
                      messaageBox={messaageBox}
                      details={details}
                      activeSportBook={activeSportBook}
                      setActiveSportBook={setActiveSportBook}
                      profileData={
                        details?.matchSetting?.length > 0
                          ? { ...details, arrayCheck: "details" }
                          : { ...profileData, arrayCheck: "profile" }
                      }
                      user={user}
                    />
                  ) : (
                    ""
                  )}
                </div>
              )}
            </>
          ) : (
            <>
              {hasPremiumFancy && (
                <PremiumFancyNew
                  preminumFancyTab={preminumFancyTab}
                  setSelectedTabFuncPreminum={[]}
                  data={preminumFancy || []}
                  betType={"premiumFancy"}
                  setSlipObj={setSlipObj}
                  setPremiumFancy={setPremiumFancy}
                  slipObj={slipObj}
                  resetSelection={resetSelection}
                  key={key}
                  messaageBox={messaageBox}
                  details={details}
                  activeSportBook={activeSportBook}
                  setActiveSportBook={setActiveSportBook}
                  profileData={
                    details?.matchSetting?.length > 0
                      ? { ...details, arrayCheck: "details" }
                      : { ...profileData, arrayCheck: "profile" }
                  }
                  user={user}
                />
              )}
            </>
          )}
        </div>
      </>
    </LayoutComponent>
  );
}

export default BidDetail;
